<template>

  <div class="">

    <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100%" variant="dark"
      id="loader">


      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF">
            <HeaderConsumer />
          </b-col>
          <b-col cols="12 headerM">
            <HeaderConsumerMobile />
          </b-col>
        </b-row>

        <br>
        <b-row>
          <b-col cols="12">
            Consumer No : <select class="customSelect" id="consList" @change="switchConsumer()">
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div>
              <b-tabs content-class="mt-3" justified active id="allTabs">
                <b-tab title="Update Profile" @click="showConsDetails('click')">
                  <b-card title="Update Profile" style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                    class="mb-2">

                    <hr />
                    <b-row>
                      <b-col col cols="6" sm="6" md="6" lg="2">
                        <span class="label">Consumer Number : </span>
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="3">
                        <span id="consumerNumber"> </span>
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                        <span class="label">Consumer Name : </span>
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                        <span id="consumerName"></span>
                      </b-col>
                    </b-row>

                    <br>
                    <b-row>
                      <b-col col cols="6" sm="6" md="6" lg="2" class="label">
                        Mobile No <span class="text-danger">*</span> :
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="3">
                        <b-form-input type="text" id="mobile" maxlength="10" autocomplete="off"
                          placeholder="Enter Mobile No" value="" trim>
                        </b-form-input>
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                        Email ID:
                      </b-col>
                      <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                        <b-form-input type="email" id="email" autocomplete="off" placeholder="Enter Email ID " value=""
                          trim>
                        </b-form-input>
                      </b-col>
                    </b-row>
                    <br>
                    <b-row class="align-items-center">
                      <!-- District -->
                      <b-col cols="6" sm="6" md="6" lg="2" class="label">
                        Select District <span class="text-danger">*</span> :
                      </b-col>
                      <b-col cols="6" sm="6" md="6" lg="3" id="districtContainer">
                        <!-- Dropdown will be injected here -->
                      </b-col>

                      <!-- Occupation -->
                      <b-col cols="6" sm="6" md="6" lg="2" class="label">
                        Occupation:
                      </b-col>
                      <b-col cols="6" sm="6" md="6" lg="3">
                        <b-form-select id="occupation" class="mb-3" v-model="selected">
                          <b-form-select-option value="null">Please select an option</b-form-select-option>
                          <b-form-select-option value="Govt">Govt Employee</b-form-select-option>
                          <b-form-select-option value="SemiGovt">Semi Govt Employee</b-form-select-option>
                          <b-form-select-option value="PSU">PSU Employee</b-form-select-option>
                          <b-form-select-option value="Others">Others</b-form-select-option>
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <!-- <br>
                          <div id="districtContainer">
                          </div> -->
                    <br>
                    <br>
                    <b-row>
                      <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                        <!-- <b-button id="updateButton" @click="sendOtp()" block squared variant="primary">
                               UPDATE</b-button> -->
                        <b-button id="updateButton" @click="updateConsumer()" block squared variant="primary">
                          UPDATE</b-button>
                        <br>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-tab>
                <b-tab title="View Balance" @click="getSmartBalance('click')">
                  <b-card style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                    <br><br>
                    <h5> Your Smart Prepaid Balance is <span style="font-size:2rem;color:#f4511e  ;font-weight:700;"
                        id="smartBalance"></span></h5>
                    <br><br>
                  </b-card>
                </b-tab>

                <b-tab title="New Recharge" @click="newRecharge()">
                  <b-card class="mb-2 " style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;">
                    <div>
                      <input id="sdCode" hidden />
                      <div class="">
                        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm"
                          style="height:100vh" variant="dark" id="loader">

                          <b-container fluid style="padding-top: 0px;text-align:left;display:block" id="consBillDiv">

                            <div class="paddingLeft30px">
                              <!-- <br>
                             <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p> -->

                              <div id="BillDetails" class="billDetails">
                                <b-row>
                                  <b-col cols=12>
                                    <span class="heading">Consumer Details</span>
                                  </b-col>
                                </b-row>
                                <hr />

                                <b-row class="paddingRow">
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Consumer Name : </span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="" id="consNamePrepaid"></span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Location : </span>
                                  </b-col>
                                  <b-col cols="12" sm="3" md="4" lg="4">
                                    <span class="" id="subDiv"></span>
                                  </b-col>
                                </b-row>
                                <b-row class="paddingRow">
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Meter No : </span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="" id="meterNo"></span>
                                  </b-col>
                                  <!-- <b-col cols="12" sm="2" md="2" lg="2">
                               <span class="label">Category : </span>
                             </b-col>
                             <b-col cols="12" sm="2" md="2" lg="2">
                               <span class="" id="category"></span>
                             </b-col> -->
                                </b-row>
                                <b-row class="paddingRow">
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Amount <span class="text-danger">*</span> : </span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <b-form-input type="number" id="amount" placeholder="Recharge  Amount"
                                      trim></b-form-input>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Confirm Amount <span class="text-danger">*</span> : </span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="3" lg="3">
                                    <b-form-input type="number" id="confirmAmount"
                                      placeholder="Confirm Recharge  Amount" trim></b-form-input>
                                  </b-col>
                                </b-row>
                                <b-row class="paddingRow">
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Mobile No <span class="text-danger">*</span> :</span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <b-form-input type="number" id="mobileNo" placeholder="Enter Mobile No" trim />
                                  </b-col>
                                  <b-col cols="12" sm="2" md="2" lg="2">
                                    <span class="label">Email ID :</span>
                                  </b-col>
                                  <b-col cols="12" sm="2" md="3" lg="3">
                                    <b-form-input type="email" id="emailId" placeholder="Enter Email ID" trim />
                                  </b-col>
                                </b-row>
                                <br>
                                <b-row>
                                  <b-col cols="12" sm="3" md="3" lg="3" offset-sm="4" offfset-md="4" offset-lg="4">

                                    <b-button block squared variant="primary" @click="payNow()">
                                      <b-icon icon="credit-card" animation=""> </b-icon> PAY NOW
                                    </b-button>

                                  </b-col>
                                </b-row>
                              </div>
                            </div>

                          </b-container>
                          <b-container fluid style="padding-top: 100px;text-align:left;display:none"
                            id="billdeskRequestDiv">

                            <br><br>
                            <b-row id="spinner" style="display:block">
                              <b-col cols=12 align="center">
                                <h3 class="">Processing Payment Request...</h3>
                                <br><br>
                                <b-spinner style="width: 10rem; height: 10rem;" variant="primary"
                                  label="Spinning"></b-spinner>
                                <br><br><br>
                                <h5 style="color:red">Please do not press back or refresh button</h5>
                              </b-col>
                            </b-row>
                            <b-row id="errorDiv" style="display:none">
                              <b-col cols=12 align="center">
                                <h2 style="color:red" id="errorMsg"></h2>
                                <br><br>
                                <b-button onclick="window.location.reload();">Go Back</b-button>
                              </b-col>
                            </b-row>
                          </b-container>
                          <br><br>
                        </b-overlay>
                        <form :action="reqUrl" method="post" id="pgrequest" hidden>
                          <input type="" name="msg" :value="messageToSend" hidden>
                          <input type="submit" id="submit" value="submit" hidden>
                        </form>
                      </div>
                    </div>

                  </b-card>
                </b-tab>

                <b-tab title="Excess Payment Refund" @click="getExcessPaymentHistory('click')">
                  <b-card title="" style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">

                    <div id="excessPaymentDiv">

                      <h3>Select the transaction from below with excess payment</h3>
                      <b-table responsive :items="excessPaymentHistory" :fields="excessPaymentHistoryFields">
                        <template v-slot:cell(claim)="data">
                          <span v-html="data.value"></span>
                        </template>
                      </b-table>
                    </div>
                    <div id="refundAmountDiv" style="display:none">
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">Admissible Refund Amount :</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="2" lg="2" style="text-align:right">
                          <span id="addmissibleAmount"
                            style="font-weight: 600;font-size: 1.2rem;color: orangered;"></span>
                        </b-col>
                      </b-row>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">Additional Charge :</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="2" lg="2" style="text-align:right">
                          <span id="additionalCharge"
                            style="font-weight: 600;font-size: 1.2rem;color: orangered;"></span>
                        </b-col>
                      </b-row><br>
                      <b-row>
                        <b-col col cols="12" sm="12" md="12" lg="12">
                          <strong>* Derivation of admissible amount for refund:</strong> Minimum of
                          {[Available credit (less adjustment of refund on conversion, if any)
                          -total of last two month's bill amount] and amount claimed}
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col col cols="12" sm="12" md="12" lg="12">
                          <strong>** Refund processing charges:</strong> Maximum of NPCI charges in preceding month plus
                          100 basis points

                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="12" sm="3" md="4" lg="3" offset-md="2" offset-lg="2">
                          <b-button block squared variant="primary" id="button" @click="showBankDetails()">
                            ACCEPT</b-button>
                          <br>
                        </b-col>
                        <b-col col cols="12" sm="3" md="4" lg="3">
                          <b-button block squared variant="primary" id="button" @click="reloadPage()">
                            CANCEL</b-button>
                          <br>
                        </b-col>

                      </b-row>
                    </div>
                    <div id="bankDetailsDiv" style="display:none">
                      <h3>Enter Bank Account Details for Refund</h3>
                      <hr>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label"> Account number:</span><span style="color:red">*</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="number" id="accountNo" trim />
                        </b-col>
                      </b-row><br>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">Account Holder Name:</span><span style="color:red">*</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="text" id="accountName" trim />
                        </b-col>
                      </b-row><br>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">Bank Name:</span><span style="color:red">*</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="text" id="bankName" trim />
                        </b-col>
                      </b-row><br>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">Bank Branch Name:</span><span style="color:red">*</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="text" id="bankBranch" trim />
                        </b-col>
                      </b-row><br>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">IFSC Code:</span><span style="color:red">*</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="text" id="ifcsCode" trim />
                        </b-col>
                      </b-row><br>
                      <b-row class="paddingRow">
                        <b-col cols="12" sm="4" md="3" lg="3">
                          <span class="label">MICR Code:</span>
                        </b-col>
                        <b-col cols="12" sm="4" md="4" lg="4" style="text-align:right">
                          <b-form-input type="text" id="mcirCode" trim />
                        </b-col>
                      </b-row><br>

                      <br>
                      <b-row>
                        <b-col col cols="12" sm="3" md="3" lg="3" offset-md="3" offset-lg="3">
                          <b-button block squared variant="primary" id="button" @click="saveBankDetails()">
                            Submit</b-button>
                          <br>
                        </b-col>

                      </b-row>
                    </div>
                  </b-card>

                </b-tab>

                <b-tab title="Billing History" @click="getBillHistory('click')">
                  <b-card title="Consumer Bill Details" style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                    class="mb-2">


                    <b-table responsive :items="consumerBill" :fields="consumerBillFields">
                      <template v-slot:cell(due_amt)="data">
                        <span v-html="data.value"></span>
                      </template>
                      <template v-slot:cell(net_amt)="data">
                        <span v-html="data.value"></span>
                      </template>
                      <!-- <template v-slot:cell(link)="data">
                          <span v-html="data.value"></span>
                        </template> -->
                      <template v-slot:cell(link)="row">
                        <img :src="`${$urlCommon}/assets/pdf-icon-3.png`" height="32" width="32"
                          style="cursor:pointer" />
                        <a href="#" class="ml-1"
                          @click.prevent="downloadBillEnglish(row.item.consNo, row.item.bill_no)">
                          English
                        </a>
                        |
                        <a href="#" class="ml-1"
                          @click.prevent="downloadBillAssamese(row.item.consNo, row.item.bill_no)">
                          অসমীয়া
                        </a>
                      </template>
                    </b-table>
                  </b-card>
                </b-tab>


                <b-tab title="Recharge History" @click="getRechargeHistory('click')">
                  <b-card title="Consumer Recharge Details" style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                    class="mb-2">

                    <b-row>
                      <b-col col cols='12' sm="12" md="12" lg="12">
                        <b-table responsive striped :items="voucherList" :fields="voucherListFields">
                          <template v-slot:cell(link)="data">
                            <span v-html="data.value"></span>
                          </template>
                        </b-table>
                      </b-col>

                    </b-row>

                  </b-card>
                </b-tab>
                <b-tab title="Monthly Statement">
                  <b-row class="paddingRow">
                    <b-col cols="4" sm="4" md="2" lg="2">
                      Select Month:
                    </b-col>
                    <b-col cols="8" sm="8" md="4" lg="3">
                      <b-form-select v-model="selectedMonth" :options="monthOptions"></b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="paddingRow">
                    <b-col cols="4" sm="4" md="2" lg="2">
                      Select Year:
                    </b-col>
                    <b-col cols="8" sm="8" md="4" lg="3">
                      <b-form-select v-model="selectedYear" :options="yearOptions"></b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="paddingRow">
                    <b-col cols="4" sm="4" md="2" lg="2">
                      Select Language:
                    </b-col>
                    <b-col cols="8" sm="8" md="8" lg="3">
                      <b-form-select v-model="selectedLanguage" :options="languageOptions"></b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="paddingRow">
                    <b-col cols="12" sm="12" md="4" lg="3" offset-lg="2" offset-md="2">
                      <b-button block squared variant="primary" class="marginTop" @click="viewStatement()">
                        <b-icon icon="credit-card" animation=""> </b-icon> VIEW STATEMENT
                      </b-button>

                    </b-col>
                  </b-row>
                  <!-- <b-col> <span class="" style="color:red;font-weight:300;font-size:1.1rem" >
                  **Considering the constrained timeline of implementation vis-à-vis no additional financial implication, recharge made during early days may depict as FPPPA charge as a part of revised energy charges on temporary basis and will be subsumed in revised energy charges at the earliest .
                 </span> </b-col>-->
                </b-tab>
                <b-tab title="TDS Adjustment Statement" @click="showTdsAdjustment('click')">
                  <b-card title="TDS(194Q) Adjustment Statement"
                    style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                    <span id="tdsSpan" style="color:red;font-weight:500;font-size:1.2rem;"></span>

                    <!-- <b-table id="tdsTable" responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields"
                      style="font-size:0.8rem;display:none"> -->
                    <b-table v-if="showTdsTable" responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields"
                      style="font-size:0.8rem">
                      <template v-slot:cell(challan_link)="data">
                        <span v-html="data.value"></span>
                      </template>
                    </b-table>
                  </b-card>
                </b-tab>
                <!-- PM Surya -->
                <b-tab title="Net Metering Profile" @click="handleNetMeteringClick">
                  <div id="mainDiv" v-show="showNetProfile">
                    <b-card v-show="showCardNormal" title="Net Metering Profile"
                      style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                      <hr />
                      <b-row>
                        <b-col cols="12" md="3" lg="3" class="label">
                          Is PM Surya Ghar Beneficiary? <span class="text-danger">*</span>
                        </b-col>

                        <b-col cols="12" md="6" lg="6">

                          <div class="d-flex align-items-center">

                            <!-- YES OPTION -->
                            <div class="d-flex align-items-center mr-4">
                              <b-form-radio v-model="isBeneficiary" value="YES" @change="handleBeneficiaryChange">
                                Yes
                              </b-form-radio>

                              <span v-if="isBeneficiary === 'YES'" class="ml-2 px-2 py-1 text-white font-weight-bold"
                                style="background-color:#28a745; border-radius:15px; font-size:12px;">
                                Net Meter
                              </span>
                            </div>

                            <!-- NO OPTION -->
                            <div class="d-flex align-items-center">
                              <b-form-radio v-model="isBeneficiary" value="NO" @change="handleBeneficiaryChange">
                                No
                              </b-form-radio>

                              <span v-if="isBeneficiary === 'NO'" class="ml-2 px-2 py-1 text-white font-weight-bold"
                                style="background-color:#dc3545; border-radius:15px; font-size:12px;">
                                EXIM Meter
                              </span>
                            </div>

                          </div>

                          <!-- Highlight message (only when nothing selected) -->
                          <div v-if="!isBeneficiary" class="d-inline-block mt-2 px-3 py-1 font-weight-bold text-white"
                            style="background-color:#8B0000; border-radius:4px;">
                            Please select an option to proceed
                          </div>

                        </b-col>
                      </b-row>
                      </br>
                      <div v-show="isBeneficiary">
                        <b-row>
                          <b-col col cols="6" sm="6" md="6" lg="2">
                            <span class="label">Consumer Number : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3">
                            <span id="NetConsumerNumber"> </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                            <span class="label">Consumer Name : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                            <span id="NetConsumerName"></span>
                          </b-col>
                        </b-row>
                        </br>
                        <b-row>
                          <b-col col cols="6" sm="6" md="6" lg="2">
                            <span class="label">Mobile Number : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3">
                            <span id="NetMobile"> </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="2">
                            <span class="label">Address : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3">
                            <span id="NetAddress"> </span>
                          </b-col>
                        </b-row>
                        <br>
                        <br>
                        <b-row>
                          <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                            <span class="label"> PM Surya Ghar/ Rodalee Application Number </span><span
                              class="text-danger">*</span> :
                          </b-col>
                          <b-col col cols="12" sm="12" md="6" lg="5">
                            <b-form-input type="text" maxlength="60" id="NetApplicationNo"
                              v-model.trim="NetApplicationNo" oninput="this.value = this.value.toUpperCase()"
                              placeholder="Enter Application Number" trim>
                            </b-form-input>
                          </b-col>
                        </b-row>
                        <br>
                        <br>
                        <b-row>
                          <b-col col cols="12" sm="12" md="6" lg="4">
                            <span class="label">PM Surya Ghar/ Rodalee Application Date <span
                                class="text-danger">*</span>:</span>
                          </b-col>
                          <b-col col cols="12" sm="12" md="6" lg="5">
                            <b-form-input type="date" id="NetApplDate" v-model.trim="NetApplDate" autocomplete="off"
                              placeholder="Enter Application Date" value="" trim>
                            </b-form-input>
                          </b-col>
                        </b-row>
                        <br>
                        <br>
                        <b-row>
                          <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                            Installed Capacity of the solar unit in kWp<span class="text-danger">*</span>:
                          </b-col>
                          <b-col col cols="12" sm="12" md="6" lg="5">
                            <b-form-input type="number" maxlength="20" id="NetCapacity" v-model.trim="NetCapacity"
                              placeholder=" Installed Capacity in kWp" trim @blur="formatCapacity">
                            </b-form-input>
                          </b-col>
                        </b-row>
                        <br><br>
                        <div v-if="isBeneficiary === 'NO'">
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              <span class="label"> Location of Agreement <span class="text-danger">*</span>:</span>
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-input type="text" maxlength="60" id="NetLocation" v-model.trim="NetLocation"
                                oninput="this.value = this.value.toUpperCase() "
                                placeholder="Enter location of agreement" trim>
                              </b-form-input>
                            </b-col>
                          </b-row>
                          <br>
                          <br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              <span class="label"> Name of Witness (Vendor):</span> <span class="text-danger">*</span>
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-input type="text" v-model="inputValue" @keydown="preventNumbers" maxlength="30"
                                id="NetWitness" oninput="this.value = this.value.toUpperCase() "
                                v-model.trim="NetWitness" placeholder="Enter Witness Name" trim>
                              </b-form-input>
                            </b-col>
                          </b-row>
                          <br><br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              <label for="consumerSignatureUpload">Select Consumer Signature
                                <span class="text-danger">*</span>:
                                <b-icon-info-circle class="ml-2" style="cursor: pointer;"
                                  v-b-popover.hover="'File size: 10KB-50KB. Dimensions: 150x100px. Formats: JPG/JPEG.'"></b-icon-info-circle>
                              </label>
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-file id="consumerSignatureUpload" v-model="consumerSignatureFile"
                                placeholder="Choose a file" accept="image/*" />
                              <b-button block squared variant="secondary" v-if="consumerSignatureFile"
                                @click="uploadSignature('consumer')" style="margin-top: 5px">
                                Upload Consumer Signature
                              </b-button>
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="3" v-if="consumerSignatureImageUrl">
                              <!-- Display the uploaded Consumer Signature -->

                              <img :src="consumerSignatureImageUrl" alt="Uploaded Consumer Signature"
                                style="max-width: 200px; max-height: 100px;" />

                            </b-col>
                          </b-row>
                          <br><br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              <label for="witnessSignatureUpload">Select Witness Signature
                                <span class="text-danger">*</span>:
                                <b-icon-info-circle class="ml-2" style="cursor: pointer;"
                                  v-b-popover.hover="'File size: 10KB-50KB. Dimensions: 150x100px. Formats: JPG/JPEG.'"></b-icon-info-circle>
                              </label></b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-file id="witnessSignatureUpload" v-model="witnessSignatureFile"
                                placeholder="Choose a file" accept="image/*" />

                              <b-button block squared variant="secondary" v-if="witnessSignatureFile"
                                @click="uploadSignature('witness')" style="margin-top: 5px">
                                Upload Witness Signature
                              </b-button>
                            </b-col>

                            <!-- Display the uploaded Witness Signature -->
                            <b-col col cols="12" sm="12" md="6" lg="3" v-if="witnessSignatureImageUrl">
                              <img :src="witnessSignatureImageUrl" alt="Uploaded Witness Signature"
                                style="max-width: 200px; max-height: 100px;" />
                            </b-col>
                          </b-row><!-- Overlay spinner (shown during file upload process) -->
                        </div>
                        <br><br>
                        <b-row>
                          <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                            <b-button block squared variant="primary" @click="showAcceptAgreement()"
                              style="margin-top:5px">
                              Accept
                            </b-button>
                            <br>
                          </b-col>
                        </b-row>
                      </div>
                    </b-card>
                  </div>

                  <div v-show="showAgreementProfile" id="agreementProfile">

                    <b-card title="Agreement Profile" style="box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">
                      <hr />
                      <b-row>
                        <b-col col cols="6" sm="12" md="12" lg="12">
                          <div id="showComment"></div>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row>
                        <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                          <b-button block squared variant="primary" id="" @click="generatePdf()"> Download
                            Agreement</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                  <div v-show="showDataProfile" id="dataProfile">
                    <b-card title="Net Metering Profile" style="box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">
                      <hr />
                      <b-row>
                        <b-col col cols="6" sm="12" md="12" lg="12">
                          <div id="showCommentNetData"></div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-tab>
                <!-- IES Energy Credential Generation -->
                <b-tab title="Energy Credential Generation" @click="handleIesCredential">
                  <div id="mainDiv" v-show="showCredential">
                    <b-card v-show="showCardNormal" title="Energy Credential Generation"
                      style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                      <hr />
                      <b-row>
                        <b-col col cols="6" sm="6" md="6" lg="2">
                          <span class="label">Consumer Number : </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3">
                          <span id="IesConsNo"> </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                          <span class="label">Consumer Name : </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                          <span id="IesConsName"></span>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row class="marginTop20px">
                        <b-col cols="6" sm="6" md="6" lg="2">
                          <span class="label">Download Format :</span>
                        </b-col>

                        <b-col cols="6" sm="6" md="6" lg="3">
                          <b-form-select v-model="selectedFormat" :options="downloadOptions">
                          </b-form-select>
                        </b-col>

                        <b-col cols="12" sm="12" md="12" lg="2" class="marginTop20px">
                          <b-button variant="primary" @click="downloadCredential">
                            Download
                          </b-button>
                        </b-col>

                      </b-row>
                    </b-card>
                  </div>
                </b-tab>
              </b-tabs>

              <div id="acceptDiv" v-show="showAcceptDiv">
                <hr>
                <div class="agreement-container">

                  <h3 class="center"> NET METERING / EXIM metering Connection Agreement</h3>


                  <div class="agreement-content">

                    This Agreement is made and entered into at <span class="declaration">{{ NetLocation }}</span> on
                    this
                    <span class="declaration">{{ NetCurrentDate }} </span> , between The Eligible Consumer, by the name
                    of
                    <span class="declaration">{{ NetConsumerName }} (Consumer No:{{ NetConsumerNumber }})</span>,having
                    premise at <span class="declaration">{{ NetAddress }}</span>, as first party.<br>
                    AND<br>
                    <b>Assam Power Distribution Licensee</b> (herein after called as Discom) represented by <b
                      style="text-decoration: underline;">SDE, <span class="declaration">{{
                        NetsubDivisionName }}</span></b>, and
                    having its registered office at <b>Guwahati, Assam </b> as second party of the agreement.<br>
                    Whereas, the eligible consumer has taken the responsibility to set up or facilitate the requisite
                    Photovoltaic
                    system of capacity <span class="declaration">{{ NetCapacity }} KWp</span> and sought connectivity to
                    the Discoms
                    under NET metering/ EXIM metering arrangement
                    And whereas, the Discoms agrees to benefit the eligible consumer for the electricity generated from
                    the grid
                    Interactive SPV plant into the power system of Discoms as per conditions of the agreement and AERC
                    (Grid
                    Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.<br><br>
                    <b>Both the party hereby agrees to as follows:</b><br><br>





                    <h6 class="agreement">1. Eligibility</h6>
                    <ul>
                      <li>
                        <strong>1.1</strong> Eligible consumer is required to be aware, in advance, of the standards and
                        conditions
                        his system has to meet for being integrated into the grid/distribution system.
                      </li>
                      <li>
                        <strong>1.2</strong> Eligible consumer agrees that connection of Photovoltaic system to DISCOM's
                        distribution
                        system shall be bound by requirements of state Distribution Code and/or DISCOM's conditions of
                        service.
                        The grid shall continue to perform with specified reliability, security, and quality as per the
                        Central
                        Electricity Authority Technical Standards for Connectivity of Distributed Generated Resources
                        Regulations,
                        2014 of the Central Electricity Authority as amended from time to time.
                      </li>
                      <li>
                        <strong>1.3</strong> The eligible consumer shall also agree to conform to the specifications and
                        standards
                        applicable to the solar PV systems as may be prescribed by the Ministry of New and Renewable
                        Energy Sources,
                        Govt. of India, from time to time.
                      </li>
                    </ul>
                    <br>
                    <h6 class="agreement">2. Technical and Interconnection Requirements</h6>
                    <ul>
                      <li>
                        <strong>2.1</strong> Eligible consumer agrees that he has installed or will install, prior to
                        connection of
                        the photovoltaic system to DISCOM's distribution system, an isolation device (both automatic and
                        inbuilt
                        within inverter and external manual relays) and agrees for the DISCOM to have access to and
                        operation of this,
                        if required, for repair and maintenance of the distribution system.
                      </li>
                      <li>
                        <strong>2.2</strong> Eligible consumer agrees that in case of a power outage on DISCOM's system,
                        the
                        photovoltaic system will shut down, unless special transfer and isolating capabilities have been
                        installed on
                        the photovoltaic system.
                      </li>
                      <li>
                        <strong>2.3</strong> All the equipment connected to the distribution system must be compliant
                        with relevant
                        international (IEEE/IEC) or Indian standards (BIS), and installations of electrical equipment
                        must comply with
                        Indian Electricity Rules, 1956, and Central Electricity Authority (Measures of Safety and
                        Electricity Supply)
                        Regulations, 2010.
                      </li>
                      <li>
                        <strong>2.4</strong> Eligible consumer agrees that DISCOM will specify the
                        interface/inter-connection point
                        and metering point.
                      </li>
                      <li>
                        <strong>2.5</strong> Eligible consumer agrees to adhere to the following power quality measures
                        as per
                        International or Indian standards and/or other measures provided by the Commission/DISCOM:
                        <ul>
                          <li><strong>a.</strong> <strong>Harmonic current:</strong> Harmonic current injections from a
                            generating
                            station shall not exceed the limits specified in IEEE 519.</li>
                          <li><strong>b.</strong> <strong>Synchronization:</strong> The photovoltaic system must be
                            equipped with a
                            grid frequency synchronization device.</li>
                          <li><strong>c.</strong> <strong>Voltage:</strong> The voltage-operating window should minimize
                            nuisance
                            tripping and operate within 80%-110% of the nominal connected voltage. Beyond a clearing
                            time of 2
                            seconds, the photovoltaic system must isolate itself from the grid.</li>
                          <li><strong>d.</strong> <strong>Flicker:</strong> Operating of the photovoltaic system should
                            not cause
                            voltage flicker exceeding the limits stated in IEC standards or equivalent Indian standards.
                          </li>
                          <li><strong>e.</strong> <strong>Frequency:</strong> When the distribution system frequency
                            deviates beyond
                            50.5Hz (upper limit) or 47.5Hz (lower limit), the photovoltaic system should not energize
                            the grid and
                            should shift to island mode.</li>
                          <li><strong>f.</strong> <strong>DC injection:</strong> The photovoltaic system should not
                            inject DC power
                            exceeding 0.5% of full-rated output at the interconnection point or 1% of the rated inverter
                            output
                            current under any operating conditions.</li>
                          <li><strong>g.</strong> <strong>Power factor:</strong> When the inverter output is greater
                            than 50%, a
                            lagging power factor of greater than 0.9 must operate.</li>
                          <li><strong>h.</strong> <strong>Islanding and Disconnection:</strong> The photovoltaic system
                            must
                            disconnect from the grid within the IEC-standardized time in case of voltage or frequency
                            variations.</li>
                          <li><strong>i.</strong> <strong>Overload and Overheat:</strong> The inverter must
                            automatically switch off
                            during overload or overheating and restart when normal conditions are restored.</li>
                          <li><strong>j.</strong> <strong>Paralleling device:</strong> The paralleling device of the
                            photovoltaic
                            system must withstand 220% of the nominal voltage at the interconnection point.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>2.6</strong> Eligible consumer agrees to furnish all operational data (e.g., voltage,
                        frequency, and
                        breaker/isolator position) as and when required by the DISCOM and, if possible, provide
                        facilities for online
                        data transfer.
                      </li>
                      <li>
                        <strong>2.7</strong> The eligible consumer shall not use a "hybrid inverter," i.e., a solar
                        inverter with a
                        provision for feeding power to the grid.
                      </li>
                    </ul>
                    <br>
                    <h6 class="agreement">3. Safety</h6>
                    <ul>
                      <li>
                        <strong>3.1</strong> Eligible consumer shall comply with the provisions of Central Electricity
                        Authority
                        (Measures Relating to Safety and Electricity Supply) Regulations 2010 and relevant provisions of
                        the National
                        Electrical Code, particularly those related to Solar PV installations.
                      </li>
                      <li>
                        <strong>3.2</strong> Eligible consumer agrees that the design, installation, maintenance, and
                        operation of the
                        photovoltaic system must ensure safety for both the photovoltaic system and DISCOM's
                        distribution system.
                      </li>
                      <li>
                        <strong>3.3</strong> If DISCOM determines that the photovoltaic system causes damage or adverse
                        effects on
                        other consumers or DISCOM's assets, the eligible consumer must disconnect the photovoltaic
                        system immediately
                        upon direction from DISCOM and rectify the issue at their own expense before reconnection.
                      </li>
                    </ul>
                    <br>
                    <h6 class="agreement">4. Clearances and Approvals</h6>
                    <ul>
                      <li><strong>4.1</strong> The eligible consumer must obtain all necessary approvals and clearances
                        (e.g.,
                        environmental and grid connection-related) before connecting the photovoltaic system to the
                        distribution
                        system.</li>
                    </ul>
                    <br>
                    <h6 class="agreement">5. Access and Disconnection</h6>
                    <ul>
                      <li><strong>5.1</strong> DISCOM shall have access to metering equipment and disconnecting means of
                        the
                        photovoltaic system, both automatic and manual, at all times.</li>
                      <li><strong>5.2</strong> In emergencies or outages where there is no access to disconnecting
                        means, DISCOM may
                        disconnect service to the premises.</li>
                    </ul>
                    <br>
                    <h6 class="agreement">6. Liabilities</h6>
                    <ul>
                      <li>
                        <strong>6.1</strong> Eligible consumer and DISCOM will indemnify each other for damages or
                        adverse effects
                        resulting from negligence or intentional misconduct in the connection and operation of the
                        photovoltaic system
                        or DISCOM's distribution system.
                      </li>
                      <li>
                        <strong>6.2</strong> Neither DISCOM nor the eligible consumer shall be liable for indirect,
                        consequential, or
                        special damages, including loss of profit, revenue, or goodwill.
                      </li>
                      <li>
                        <strong>6.3</strong> DISCOM shall not be liable for fiscal or other incentives provided to the
                        eligible
                        consumer by the central government.
                      </li>
                    </ul>
                    <br>
                    <h6 class="agreement">7. Commercial Settlement</h6>
                    <ul>
                      <li><strong>7.1</strong> All commercial settlements under this agreement will follow the
                        regulations of the
                        Assam Electricity Regulatory Commission.</li>
                    </ul>
                    <br>
                    <h6 class="agreement">8. Connection Costs</h6>
                    <ul>
                      <li><strong>8.1</strong> The eligible consumer shall bear all costs related to setting up the
                        photovoltaic
                        system, including metering and interconnection costs, as well as modifications/upgrades to the
                        distribution
                        facilities.</li>
                      <li><strong>8.2</strong> The eligible consumer must bear the cost of interconnection equipment
                        such as isolators
                        and meters.</li>
                    </ul>
                    <br>
                    <h6 class="agreement">9. Termination</h6>
                    <ul>
                      <li><strong>9.1</strong> The eligible consumer may terminate the agreement at any time by
                        providing DISCOM with
                        90 days' prior notice.</li>
                      <li><strong>9.2</strong> DISCOM has the right to terminate the agreement with 30 days' written
                        notice if the
                        eligible consumer breaches a term and fails to remedy it within the notice period.</li>
                      <li><strong>9.3</strong> Upon termination, the eligible consumer must disconnect the photovoltaic
                        system from
                        DISCOM's distribution system to DISCOM's satisfaction.</li>
                    </ul>
                    <br>

                    <div></div>

                    <br>

                  </div>
                  <br>
                  <b-form-checkbox class="decl" id="checkbox-1" name="checkbox-1" value="accepted"
                    v-model="undertakingAccepted">

                    I hereby declare that the above made statements are true to the best of my knowledge and belief, and
                    that I
                    understand, any misrepresentation/misinformation shall subject myself to necessary action as deemed
                    fit and
                    proper.
                  </b-form-checkbox>
                  <br>
                  <div class="decl" style="padding-left:2vw "> In the witness, where of Mr. <span class="declaration">{{
                    NetWitness }}
                    </span>for and on behalf of <span class="declaration">{{ NetConsumerName }} </span>(Eligible
                    consumer) and <b style="text-decoration: underline;">SDE, <span class="declaration">{{
                      NetsubDivisionName }}</span> </b> for and
                    on behalf of <b>Assam Power Distribution Licensee </b>(Discom) agree to this agreement.
                  </div>
                  <b-row>
                    <b-col cols="6" sm="6" md="6" lg="6" v-if="consumerSignatureImageUrl"> <span class="decl">Signature
                        of
                        consumer</span>
                      <img :src="consumerSignatureImageUrl" alt="Uploaded Consumer Signature"
                        style="max-width: 150px; max-height: 100px;" />
                    </b-col>
                    <b-col cols="6" sm="6" md="6" lg="6" v-if="witnessSignatureImageUrl"> <span class="decl">Signature
                        of
                        Witness</span>
                      <img :src="witnessSignatureImageUrl" alt="Uploaded Witness Signature"
                        style="max-width: 150px; max-height: 100px;" />
                    </b-col>

                  </b-row>
                  <span style="padding-right:1vw ; font-size: 14px;"> Date:<span class="declaration">{{ NetCurrentDate
                      }}</span>
                  </span>

                  <br>

                  <span style="padding-right:1vw; font-size: 14px;">Place: <span class="declaration">
                      {{ NetLocation }}</span></span>
                </div>

                <b-row>

                  <b-col col cols="12" sm="12" md="2" lg="2" offset-md="4" offset-lg="4">
                    <b-button block squared variant="primary" id="saveAgreementbutton" @click="saveAgreement()"
                      style="margin-top:2px"> Submit</b-button>

                  </b-col>

                  <b-col col cols="12" sm="12" md="2" lg="2">
                    <b-button block squared variant="danger" @click="reloadPage()" style="margin-top:2px">
                      Cancel</b-button>
                  </b-col>
                </b-row> <br>


              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>

    </b-overlay>
    <br>



    <b-button id="success-btn" @click="$bvModal.show('successModal')" hidden></b-button>
    <b-button id="failure-btn" @click="$bvModal.show('failureModal')" hidden></b-button>

    <!-- <b-modal id="netMeterModal" ref="netMeterModal" :hide-backdrop="false" no-close-on-backdrop no-close-on-esc centered
      title="Confirmation">
      <p>Are you a PMSGY Beneficiary?</p>

      <template #modal-footer>
        <b-button variant="success" @click="confirmYes">Yes</b-button>
        <b-button variant="danger" @click="confirmNo">No</b-button>
      </template>
    </b-modal> -->
    <b-modal id="beneficiaryModal" centered hide-footer title="Selected Meter Type">
      <div class="text-center font-weight-bold"
          :class="isBeneficiary === 'YES' ? 'text-success' : 'text-danger'">
        {{ beneficiaryMessage }}
      </div>

      <div class="text-center mt-3">
        <b-button variant="primary" @click="$bvModal.hide('beneficiaryModal')">
          OK
        </b-button>
      </div>
    </b-modal>

    <b-modal id="excessPaymentModal" centered scrollable title="Enter Excess Payment Amount" :static="true" hide-footer>
      <b-form-input type="number" id="excessAmountUser" placeholder="Enter Excess Payment Amount" trim />
      <br><br>
      <b-button style="width:8rem" variant="outline-primary" @click="calculateExcessPayement()">submit</b-button>
    </b-modal>

    <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg" style="color:red"></span>
      <br><br>
      <b-button style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="profilesuccessModal" centered scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p class="success">Profile Successfully Updated !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()">OK</b-button>
      </p>
    </b-modal>
    <b-modal id="netAgreementsuccessModal" centered scrollable title="Save Agreement" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p class="success">Agreement Successfully Uploaded !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="generatePdf()">OK </b-button>
      </p>
    </b-modal>
    <b-modal id="agreementSuccessModal" centered scrollable title="Save Agreement" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p class="success">Data Successfully Uploaded !<br><br>
        <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage">OK </b-button>
      </p>
    </b-modal>
    <b-modal id="netAgreementfailureModal" centered scrollable title="Save Agreement" hide-footer hide-header>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
      </svg>
      <p class="error">Agreement could not be uploaded !<br><br>
        <b-button variant="outline-primary" id="" @click="reloadPage()">OK </b-button>

      </p>
    </b-modal>
    <b-modal id="netAgreementrejectModal" centered scrollable title="Agreement Rejected" hide-footer hide-header
      backdrop="static" @click.stop.prevent>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
      </svg>

      <p id="rejectedModalMsg" class="error"> Your application has been rejected. Please update the details and
        re-submit.<br><br><b-button variant="outline-primary" id="" @click="updateNetAgreement()">OK </b-button></p>
    </b-modal>
    <b-modal id="profilefailureModal" centered scrollable title="Profile Update" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p class="error">Profile Update Failed ! </p>
    </b-modal>
    <b-modal id="successModal" centered scrollable title="Success" hide-header hide-footer no-close-on-backdrop
      no-close-on-esc>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p class="success"><span id="">{{ successMsg }}</span><br><br>
        <b-row class="paddingRow ">
          <b-col cols="12" sm="12" md="12" lg="12">
            <b-button class="btn btn-outline " variant="outline-danger" id="" @click="generateUndertakingPdf()">Download
              Acknowledgement</b-button>
          </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="12" md="12" lg="12">
            <b-button class="btn btn-outline" variant="outline-primary" @click="reloadPage()">CLOSE</b-button>
          </b-col>
        </b-row>
      </p>
    </b-modal>

    <b-modal id="existModal" centered scrollable title="ALERT" hide-footer no-close-on-backdrop no-close-on-esc>
      <p class="success">Excess payment already claimed against this bill<br><br>
        <b-row class="paddingRow ">
          <b-col cols="12" sm="12" md="12" lg="12">
            <b-button class="btn btn-outline " variant="outline-danger" @click="generateUndertakingPdf()">Download
              Acknowledgement</b-button>
          </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="12" md="12" lg="12">
            <b-button class="btn btn-outline" variant="outline-primary" @click="reloadPage()">CLOSE</b-button>
          </b-col>
        </b-row>
      </p>
    </b-modal>

    <b-modal id="failureModal" centered scrollable title="Failure" hide-footer>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
          cy="65.1" r="62.1" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
          stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
      </svg>
      <p class="error" id="">{{ failureMsg }}</p><br>

    </b-modal>

    <b-modal id="redirectModal" centered scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="redirectModalMsg" style="color:red"> </span>
      <br><br>
      <b-button style="width:8rem" variant="outline-info" @click="redirect()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>
import Chart from 'chart.js';
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var CryptoJS = require("crypto-js");
var checked = 0;
var thColor = '#0288d1';
var oldMob = "";
var click = [];
var sdCode = "";
var consNo = "";
var mobile = "";
var accessToken = "";
var consList;
var consName = "";
var vendor = "";
var isSmart = "";
var bankConsNo = "";
var bankReceiptNo = "";
var rcName = "";
var rcOffice = "";
var rcDate = "";
var rcApplNo = "";
var rcAmt = "";
var rcAddAmt = "";
var consumerNumberGlobal = "";
var consumermobileGlobal = "";
var consumerNameGlobal = "";
var consumerAddressGlobal = "";
var subdivisionNameGlobal = "";
var ov = "N";
Vue.use(Vuex)
//const urlCommon = "http://localhost:8081/website";
//  const urlCommon = "https://www.apdcl.org/website";

export default {
  name: 'ConsumerDashboard',
  components: {

    'HeaderConsumer': HeaderConsumer,
    'HeaderConsumerMobile': HeaderConsumerMobile
    //MarqueeText

  },
  data() {
    return {
      selectedFormat: null,
      downloadOptions: [
        { value: null, text: "Select Format", disabled: true },
        { value: "pdf", text: "PDF" },
        { value: "json", text: "JSON" }
      ],
      isBeneficiary: null,
      beneficiaryMessage: '',
      beneficiaryOptions: [
        { text: 'Yes', value: 'YES' },
        { text: 'No', value: 'NO' }
      ],
      isAgreementAccepted: false,
      showTdsTable: false,
      showNetProfile: true,  // Flag to show/hide Net Metering Profile
      showCredential: true,
      showAcceptDiv: false,
      showAgreementMessage: false,
      showAgreementProfile: false,
      showDataProfile: false,   
      agreementMessage: '',
      districtFlag: false,
      NetConsumerNumber: "",
      NetConsumerName: "",
      NetApplicationNo: "",
      NetAddress: "",
      NetApplDate: "",
      NetCurrentDate: "",
      NetApplMonth: "",
      NetMobile: "",
      NetWitness: "",
      NetCapacity: "",
      NetLocation: "",
      undertakingAccepted: false,//checkbox in undertaking
      consumerSignatureFile: null,
      witnessSignatureFile: null,
      consumerSignatureImageUrl: null,
      witnessSignatureImageUrl: null,
      isValidConsumer: false,
      isValidWitness: false,
      isConsumerSignatureValid: false,
      isWitnessSignatureValid: false,
      inputValue: "",
      editableFields: false,
      NetsubDivisionName: "",
      activeContent: "netProfile",
      show: false,
      show1: false,
      // showCardPMSGY: false,
      showCardNormal: true,
      messageToSend: "",
      reqUrl: "",
      consType: "",
      smartBalance: "O",
      checkboxStatus: "not_accepted",
      selected: null,
      successMsg: "",
      failureMsg: "",
      voucherList: [],
      NetconsDetails: [],
      consumerBillFields: [
        { key: 'bill_no', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_date', label: 'Bill Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_date', label: 'Due Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_amt', label: 'Due Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'net_amt', label: 'Net Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'right' } },
        { key: 'link', label: 'Download', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } }
      ],
      consumerBill: [],
      voucherListFields: [
        { key: 'receipt', label: 'Receipt No', thStyle: { width: '15vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'amount', label: 'Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'date', label: 'Payment Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'mode', label: 'Mode', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ],
      excessPaymentHistoryFields: [
        { key: 'receipt', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'date', label: 'Payment Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'amount', label: 'Paid Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'mode', label: 'Payment Mode', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'claim', label: 'Select excess payment', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ],
      excessPaymentHistory: [],
      tdsAdjustmentFields: [
        { key: 'sl_no', label: 'SL No', thStyle: { width: '3vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'cons_no', label: 'Consumer No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'tan_no', label: 'TAN No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_no', label: 'Bill No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'tds_amt', label: 'TDS Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_no', label: 'Challan No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_date', label: 'Challan Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_amt', label: 'Challan Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'upload_date', label: 'Upload Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'processed_flag', label: 'Processed', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'processed_date', label: 'Processed Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_link', label: 'Challan Link', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }

      ],
      tdsAdjustment: [],
      consList: [],
      consDetails: [],
      tdsAdjustment: [],
      message: [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
      selectedMonth: null,
      monthOptions: [
        { value: null, text: 'Please select month' },
        { value: 'january', text: 'January' },
        { value: 'february', text: 'February' },
        { value: 'march', text: 'March' },
        { value: 'april', text: 'April' },
        { value: 'may', text: 'May' },
        { value: 'june', text: 'June' },
        { value: 'july', text: 'July' },
        { value: 'august', text: 'August' },
        { value: 'september', text: 'September' },
        { value: 'october', text: 'October' },
        { value: 'november', text: 'November' },
        { value: 'december', text: 'December' }
      ],
      selectedYear: null,
      yearOptions: [],
      selectedLanguage: null,
      languageOptions: [
        { value: null, text: 'Please select language' },
        { value: 'english', text: 'English' },
        { value: 'assamese', text: 'অসমীয়া' }
      ],
      invoicePDF: ""
    }
  },

  methods:
  {
    reloadPage() {
      window.location.reload();
    },
    handleBeneficiaryChange(value) {
      if (value === 'YES') {
        this.beneficiaryMessage = 'Net Meter is selected';
      } else if (value === 'NO') {
        this.beneficiaryMessage = 'EXIM Meter is selected';
      }
      this.$nextTick(() => {
        this.$bvModal.show('beneficiaryModal');
      });
    },
    handleNetMeteringClick() {
      // this.showCardPMSGY = false;
      // this.showCardNormal = false;
      // this.$refs.netMeterModal.show();
      this.showDataProfile = false;
      this.showAgreementProfile = false;
      this.showCardNormal = true;
      this.showNetConsDetails('click');
    },
    handleIesCredential() {
      this.showCardNormal = true;
      document.getElementById("IesConsNo").innerHTML = consumerNumberGlobal;
      document.getElementById("IesConsName").innerHTML = consumerNameGlobal;
    },
    downloadCredential() {
      if (!this.selectedFormat) {
        this.$bvToast.toast("Please Select a format!", {
          title: "Danger",
          variant: "danger",
          solid: true,
        });
        return;
      }
      const data = {
        "consNo": consumerNumberGlobal,
        "docType": this.selectedFormat,
        "mobileNo": sessionStorage.getItem("mobile")
      };
      console.log("data::::" + JSON.stringify(data));
      let config = {
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/ies/getConsumerDataForIES',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: this.selectedFormat === "pdf" ? "blob" : "json",
        data: data
      }
      this.show = true;
      var parent = this;
      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            // console.log("response::"+response.data)
            // console.log(response.data instanceof Blob);
            if (parent.selectedFormat === "json") {

              const dataStr = JSON.stringify(response.data, null, 2);
              const blob = new Blob([dataStr], { type: "application/json" });

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "energyCredential.json";

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              URL.revokeObjectURL(link.href);

            } else if (parent.selectedFormat === "pdf") {

              const blob = new Blob([response.data], { type: "application/pdf" });

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "energyCredential.pdf";

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              URL.revokeObjectURL(link.href);
            }
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
      } catch (error) {
        console.error("Error calling server", error.response || error);
        this.show = false;
      }
      // console.log("Download format:", this.selectedFormat);

      // let url = `https://uat.apdclrms.com/restapi/v2/ies/getUtilityConsumerData?consNo=${consumerNumberGlobal}&docType=${this.selectedFormat}`;

      // axios.request({
      //   method: "POST",
      //   url: url,
      //   headers: {
      //     "x-api-key": "YXBkY2xAdWF0IyQlXiZeJSQjQA=="
      //   },
      //   responseType: this.selectedFormat === "pdf" ? "blob" : "json"
      // })
      //   .then((response) => {
      //     this.show = false;
      // if (this.selectedFormat === "json") {

      //   const dataStr = JSON.stringify(response.data, null, 2);
      //   const blob = new Blob([dataStr], { type: "application/json" });

      //   const link = document.createElement("a");
      //   link.href = URL.createObjectURL(blob);
      //   link.download = "energyCredential.json";
      //   link.click();

      // } else if (this.selectedFormat === "pdf") {

      //   const blob = new Blob([response.data], { type: "application/pdf" });

      //   const link = document.createElement("a");
      //   link.href = URL.createObjectURL(blob);
      //   link.download = "energyCredential.pdf";
      //   link.click();
      // }
      //   })
      //   .catch((error) => {
      //     console.error("API Error:", error);
      //   });
    },
    saveAgreementDirectly() {
      const dta = this.NetApplDate;
      const formatdate = dta.split("-");
      const applDateFormatted = `${formatdate[2]}/${formatdate[1]}/${formatdate[0]}`;
      const subDivisionName = subdivisionNameGlobal;
      const location = document.getElementById("NetLocation").value.trim();
      const capacity = document.getElementById("NetCapacity").value.trim();
      const ConsName = consumerNameGlobal;
      const NetAdd = consumerAddressGlobal;
      const currDateFormatted = applDateFormatted;
      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      var applNo = document.getElementById("NetApplicationNo").value;
      const payload = {
        consNo: consNo,
        applNo: applNo,
        applDate: dta,
        consName: ConsName,
        address: NetAdd,
        capacity: capacity,
        mobNo: mobile,
        subName: subDivisionName,
        location: location
        // beneficiary: 'YES'
      };

      const formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(payload)], { type: "application/json" }));
      formData.append("consNo", consNo);
      formData.append("mobileNo", mobile);

      var parent = this;
      parent.show = true;

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/saveAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      };

      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            // console.log("status:::"+response.data.status);
            // console.log("Server Response:", response.data);

            if (response.data.status == "success") {
              //   this.$bvToast.toast("Application submitted successfully!", {
              //   title: "Success",
              //   variant: "success",
              //   solid: true,
              // });

              parent.$bvModal.show('netAgreementsuccessModal');
              //this.generatePdf(dataToSend);

            }
            else {
              parent.$bvModal.show('netAgreementfailureModal');
            }
          });
      } catch (error) {
        console.error("Error calling server", error.response || error);
        this.show = false;
      }
    },
    // confirmYes() {
    //   this.$refs.netMeterModal.hide();
    //   this.showCardPMSGY = true;   
    //   this.showCardNormal = false;  
    // },

    // confirmNo() {
    //   this.$refs.netMeterModal.hide();
    //   this.showCardPMSGY = false;   
    //   this.showCardNormal = true;   
    //   this.showNetConsDetails('click');
    // },

    preventNumbers(event) {
      if (event.key >= '0' && event.key <= '9') {
        event.preventDefault(); // Block numbers
      }
    },
    formatCapacity() {
      if (!this.NetCapacity) return;

      let formattedValue = this.NetCapacity.toString();

      // Allow digits & dot only
      formattedValue = formattedValue.replace(/[^0-9.]/g, '');

      // Allow only one dot
      const parts = formattedValue.split('.');
      if (parts.length > 2) {
        formattedValue = parts[0] + '.' + parts[1];
      }

      // Limit to 2 decimal places
      if (formattedValue.includes('.')) {
        const [intPart, decPart] = formattedValue.split('.');
        formattedValue = intPart + '.' + decPart.substring(0, 2);
      } else {
        formattedValue = formattedValue + '.00';
      }

      // ✅ Update Vue model (THIS is the key)
      this.NetCapacity = formattedValue;
    },
    showNetConsDetails(action) {
      // console.log("inside Netcons");
      if ((action === "change") || (action === "click" && this.NetconsDetails.length == 0)) {
        var parent = this;
        this.show = true;
        this.checkAgreementStatus().then((isAgreementSubmitted) => {
          if (isAgreementSubmitted === "dataSubmitted") {
            this.showDataConfirmation();
          }
          else if (isAgreementSubmitted === "submitted") {
            this.showAgreementConfirmation();
          }
          else if (isAgreementSubmitted === "accepted") {
            this.showAgreementConfirmation();
          }
          else if (isAgreementSubmitted === "rejected") {
            this.$bvModal.show('netAgreementrejectModal');
          }
          else {
            // this.showNetProfile = true; 
            document.getElementById("mainDiv").style.display = 'block';
            // Show net profile
            this.showAgreementProfile = false;
            this.showDataProfile = false;
            const consNo = document.getElementById('consList').value;
            // this.show = true;

            const data = JSON.stringify({
              "consNo": consNo,
              "mobileNo": mobile
            });
            const config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: this.$urlCommon + '/api/web/auth/getConsDetails',
              headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
              },
              data: data
            };

            axios.request(config)
              .then((response) => {
                parent.show = false;
                // console.log(response.data);

                if (response.data.message === "00") {
                  const data = response.data;
                  this.oldMob = data.mobile_no;
                  this.NetsubDivisionName = data.subDivisionName;
                  subdivisionNameGlobal = data.subDivisionName;

                  // this.NetConsumerName = 
                  document.getElementById("NetConsumerNumber").innerHTML = data.cons_no;
                  document.getElementById("NetConsumerName").innerHTML = data.cons_name;
                  document.getElementById("NetMobile").innerHTML = data.mobile_no;
                  document.getElementById("NetAddress").innerHTML = data.cons_ADD1;

                  this.NetConsumerName = data.cons_name; // Save to Vue data property
                  this.NetAddress = data.cons_ADD1;
                  sessionStorage.setItem('NetConsumerName', this.NetConsumerName); // Save to sessionStorage
                  sessionStorage.setItem('NetAddress', this.NetAddress);

                  this.consDetails.push(data.cons_no);

                } else {
                  this.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
                }
              })
              .catch((e) => {
                this.show = false;
                console.log("Caught", e.response.data.error);
                if (e.response.data.error === "Forbidden") {
                  this.$bvModal.show('redirectModal');
                  document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
                }
              });



          }
        })
      }
    },
    async checkAgreementStatus() {
      let agreementStatus = null;
      const consNo = document.getElementById("consList").value;
      const mobile = sessionStorage.getItem("mobile");
      const dataToSearch = {
        consNo: consNo,
        mobileNo: mobile
      };

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: dataToSearch
      };

      try {
        const response = await axios.request(config);
        const len = response.data.length;

        if (response && response.data && response.data.length > 0) {
          const serverStatus = response.data[len - 1].agreement_status;
          const location = response.data[len - 1].location;
          if (serverStatus === "1" && location == "") {
            agreementStatus = "dataSubmitted";
            document.getElementById("showCommentNetData").innerHTML =
              'Your data has been uploaded successfully.';
          }
          else if (serverStatus === "1") {
            if (response.data[len - 1].sde_sig === "") {

              agreementStatus = "submitted";
              document.getElementById("showComment").innerHTML =
                'Your document has been uploaded successfully. Please download your <span style="font-weight:bold; color:#d6602d">Provisional Agreement</span>.';
            }
          }

          else if (serverStatus === "2") {
            // console.log("inside status=2 (accepted)");
            agreementStatus = "accepted";
            document.getElementById("showComment").innerHTML =
              'Your document has been uploaded successfully. Please download your <span style="font-weight:bold; color:#d6602d">Final Agreement</span>.';
          }
          else if (serverStatus === "3") {
            // console.log("inside status=3 (rejected)");
            agreementStatus = "rejected";
          }
          else {
            // console.log("inside not submitted");
            agreementStatus = "not_submitted";
          }
        } else {
          console.log("No valid data received from server.");
          //agreementStatus = "not_submitted";
        }
      } catch (err) {
        console.error("Error calling server", err);
      }
      //console.log('agreementstatus:', agreementStatus);
      return agreementStatus;
    },
    showDataConfirmation() {
      this.show = false;
      this.showNetProfile = false;  // Hide the net metering profile
      this.showAgreementProfile = false; //Hide agreement profile
      this.showDataProfile = true;  // Show data profile
      this.activeContent = 'dataProfile';

    },
    showAgreementConfirmation() {
      this.show = false;
      this.showNetProfile = false;  // Hide the net metering profile
      this.showDataProfile = false; // Hide data profile 
      this.showAgreementProfile = true;  // Show agreement profile
      this.activeContent = 'agreementProfile';

    },
    updateNetAgreement() {
      //console.log("inside updatenetagreement");
      this.show = false;
      this.$bvModal.hide('netAgreementrejectModal');
      this.showNetProfile = true;
      this.showDataProfile = false;
      this.showAgreementProfile = false;
      document.getElementById("mainDiv").style.display = 'block';

      this.NetConsumerNumber = consumerNumberGlobal;
      //this.NetConsumerName = sessionStorage.getItem('NetConsumerName') || this.NetConsumerName;
      this.NetConsumerName = consumerNameGlobal;
      this.NetAddress = consumerAddressGlobal;
      this.NetMobile = consumermobileGlobal;
      this.NetsubDivisionName = subdivisionNameGlobal;
      //this.NetAddress = sessionStorage.getItem('NetAddress') || this.NetAddress;
      //  console.log('Address',this.NetAddress );

      // console.log('consno',this.NetConsumerNumber );
      // console.log('consmobile',this.NetMobile );
      // console.log('NetsubDivisionName',this.NetsubDivisionName );

      document.getElementById("NetConsumerNumber").innerHTML = this.NetConsumerNumber;
      document.getElementById("NetConsumerName").innerHTML = this.NetConsumerName;
      document.getElementById("NetMobile").innerHTML = this.NetMobile;
      document.getElementById("NetAddress").innerHTML = this.NetAddress;


    },
    showAcceptAgreement() {
      if (this.isBeneficiary === 'YES') {
        if (this.validateBeneficiaryYes()) {
          this.submitBeneficiaryYes()
        }
      } else {
        if (this.validateBeneficiaryNo()) {
          this.submitBeneficiaryNo()
        }
      }
    },
    validateBeneficiaryYes() {
      if (!this.NetApplicationNo) {
        this.$bvToast.toast('Enter Application No!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplicationNo").focus();
        return false
      }

      if (!this.NetApplDate) {
        this.$bvToast.toast('Enter Application Date!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplDate").focus();
        return false
      }

      if (!this.NetCapacity || this.NetCapacity <= 0) {
        this.$bvToast.toast('Enter Installed Capacity!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetCapacity").focus();
        return false
      }
      return true
    },
    submitBeneficiaryYes() {
      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      const NetAdd = consumerAddressGlobal;
      const ConsName = consumerNameGlobal;
      const data = {
        consNo: consNo,
        applNo: this.NetApplicationNo,
        applDate: this.NetApplDate,
        consName: consumerNameGlobal,
        mobNo: mobile,
        mobileNo: mobile,
        address: consumerAddressGlobal,
        capacity: this.NetCapacity
      }

      var parent = this;
      parent.show = true;

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/savePmsgyData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            console.log("status:::" + JSON.stringify(response.data.status));

            if (response.data.status == "success") {
              parent.$bvModal.show('agreementSuccessModal');
            }
            else {
              parent.$bvModal.show('netAgreementfailureModal');
            }
          });
      } catch (error) {
        console.error("Error calling server", error);
      }
    },
    validateBeneficiaryNo() {
      if (!this.validateBeneficiaryYes()) return false

      if (!this.NetApplicationNo) {
        this.$bvToast.toast('Enter Application No!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplicationNo").focus();
        return false
      }

      if (!this.NetApplDate) {
        this.$bvToast.toast('Enter Application Date!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplDate").focus();
        return false
      }

      if (!this.NetCapacity || this.NetCapacity <= 0) {
        this.$bvToast.toast('Enter Installed Capacity!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetCapacity").focus();
        return false
      }

      if (!this.NetLocation) {
        this.$bvToast.toast('Enter Location!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetLocation").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.NetWitness) {
        this.$bvToast.toast('Enter Witness Name!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetWitness").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.consumerSignatureImageUrl && ((!this.consumerSignatureFile) || (!this.isConsumerSignatureValid))) {
        this.$bvToast.toast('Consumer Signature is required!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("consumerSignatureImageUrl").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.witnessSignatureImageUrl && ((!this.witnessSignatureFile) || (!this.isWitnessSignatureValid))) {
        this.$bvToast.toast('Witness Signature is required!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("witnessSignatureImageUrl").focus();
        return false
      }

      return true
    },
    submitBeneficiaryNo() {
      var currentDate = new Date();
      var formatcurrentdDate = currentDate.toLocaleDateString('en-GB');
      this.NetCurrentDate = formatcurrentdDate;
      this.NetConsumerName = consumerNameGlobal;
      this.NetConsumerNumber = consumerNumberGlobal;
      // Toggle visibility
      if (this.isBeneficiary === 'NO') {
        this.showNetProfile = false;  // Hide the net metering profile
        this.showDataProfile = false;
        this.showAgreementProfile = false;
        this.showAcceptDiv = true;   // Show the agreement form
        window.scrollTo(0, 0);
      }
      else {
        this.$bvModal.show('netAgreementfailureModal');
      }
    },
    async uploadSignature(type) {

      this.show = true;
      const file = type === "consumer" ? this.consumerSignatureFile : this.witnessSignatureFile;

      if (!file) {
        this.show = false;
        this.$bvToast.toast("Please select a file first!", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate file type (JPG/JPEG)
      const validTypes = ['image/jpeg'];
      if (!validTypes.includes(file.type)) {
        this.show = false; // Hide the spinner if validation fails
        this.$bvToast.toast("Only JPG or JPEG files are allowed.", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate file size (10KB to 50KB)
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB < 10 || fileSizeKB > 50) {
        this.show = false; // Hide the spinner if validation fails
        this.$bvToast.toast("File size must be between 10KB and 50KB.", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate image dimensions (150x100)
      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = () => {
          if (img.width !== 150 || img.height !== 100) {
            this.show = false; // Hide the spinner if dimensions are invalid
            this.$bvToast.toast("Image dimensions must be 150x100 pixels.", {
              title: "Alert",
              variant: "danger",
              solid: true,
            });
            reject("Invalid dimensions");
          } else {
            resolve(); // Valid dimensions
          }
        };
        img.onerror = () => reject("Image load error");

        // Trigger image load
        img.src = URL.createObjectURL(file);
      });

      // If validation is successful, proceed with the file upload
      const reader = new FileReader();

      reader.onload = (e) => {
        if (type === "consumer") {
          this.consumerSignatureImageUrl = e.target.result;
          this.isConsumerSignatureValid = true; // Set flag for validation
        } else if (type === "witness") {
          this.witnessSignatureImageUrl = e.target.result;
          this.isWitnessSignatureValid = true; // Set flag for validation
        }

        this.show = false; // Hide the spinner once the upload is complete

        this.$bvToast.toast("Signature uploaded successfully!", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      };

      reader.onerror = () => {
        this.show = false; // Hide the spinner if an error occurs
        this.$bvToast.toast("Error uploading the signature.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      };

      // Start reading the file as data URL
      reader.readAsDataURL(file);
    },
    saveAgreement() {
      if (!this.undertakingAccepted) {
        this.$bvToast.toast("Please accept the declaration!", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        document.getElementById("checkbox-1").focus();
        return;
      }

      // const dta = document.getElementById("NetApplicationDate").value;
      const dta = this.NetApplDate;
      const formatdate = dta.split("-");
      const applDateFormatted = `${formatdate[2]}/${formatdate[1]}/${formatdate[0]}`;
      const subDivisionName = subdivisionNameGlobal;
      const witness = document.getElementById("NetWitness").value.trim();
      const location = document.getElementById("NetLocation").value.trim();
      const capacity = document.getElementById("NetCapacity").value.trim();
      const ConsName = consumerNameGlobal;
      const NetAdd = consumerAddressGlobal;
      const currDateFormatted = applDateFormatted;
      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      var applNo = document.getElementById("NetApplicationNo").value;
      //  console.log('insidesaveagreement::: location',location);
      //  console.log(' subDivisionNameGlobal', subDivisionName);
      //  console.log('location',location);

      const dataToSend = {
        consNo: consNo,
        applNo: applNo,
        applDate: dta,
        consName: ConsName,
        address: NetAdd,
        capacity: capacity,
        witnessName: witness,
        mobNo: mobile,
        subName: subDivisionName,
        location: location
        //undertakingAccepted: this.undertakingAccepted,
        //currdate: currDateFormatted,
      };

      // console.log("dataToSend::::"+JSON.stringify(dataToSend));

      // let witnessSignatureUrl = this.witnessSignatureImageUrl;  
      // let consumerSignatureUrl = this.consumerSignatureImageUrl;
      const consumerSignature = document.querySelector("#consumerSignatureUpload").files[0];
      const witnessSignature = document.querySelector("#witnessSignatureUpload").files[0];
      const formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(dataToSend)], { type: "application/json" }));
      formData.append("consumerSig", consumerSignature);
      formData.append("witnessSig", witnessSignature);
      formData.append("consNo", consNo);
      formData.append("mobileNo", mobile);
      // Call the PDF generation function with the data
      //this.generatePdf(dataToSend);



      var parent = this;
      parent.show = true;
      document.getElementById('saveAgreementbutton').disabled = true;


      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/saveAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      };

      // console.log("config::::"+JSON.stringify(config));


      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            // console.log("status:::"+response.data.status);
            // console.log("Server Response:", response.data);

            if (response.data.status == "success") {
              //   this.$bvToast.toast("Application submitted successfully!", {
              //   title: "Success",
              //   variant: "success",
              //   solid: true,
              // });

              parent.$bvModal.show('netAgreementsuccessModal');
              //this.generatePdf(dataToSend);

            }
            else {


              parent.$bvModal.show('netAgreementfailureModal');

            }
            document.getElementById('saveAgreementbutton').disabled = false;
          });
      } catch (error) {
        console.error("Error calling server", error.response || error);
        this.show = false;
        document.getElementById('saveAgreementbutton').disabled = false;
      }
    },
    generatePdf() {

      //console.log("inside generatePdf");

      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      const dataToSearch = {
        consNo: consNo,
        mobileNo: mobile

      }
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: dataToSearch
      };
      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;

          //console.log("response data:::"+JSON.stringify(response.data[0]));

          var len = response.data.length;
          var NetAdd = response.data[len - 1].address;
          var date = response.data[len - 1].appl_date;

          var subDivisionName = response.data[len - 1].subName;
          var witness = response.data[len - 1].witness_name;
          var location = response.data[len - 1].location;
          var capacity = response.data[len - 1].capacity.toFixed(2);
          var ConsName = response.data[len - 1].cons_name;
          var ConsNo = response.data[len - 1].cons_no;
          //var currentdate = new Date(); 
          //var  currDateFormatted = currentdate.toLocaleDateString('en-GB');
          var witnessSignatureUrl = response.data[len - 1].witness_sig;
          var consumerSignatureUrl = response.data[len - 1].cons_sig;
          var sdeSignatureUrl = response.data[len - 1].sde_sig;

          var sdeSignatureDate = response.data[len - 1].sde_sig_dt;
          var formatdate = sdeSignatureDate.split("-");
          var sdeSignatureDateformatted = formatdate[2] + "/" + formatdate[1] + "/" + formatdate[0];
          var conssigdate = response.data[len - 1].cons_sig_dt;
          var formatconssigdate = conssigdate.split("-");
          var conssigdateformatted = formatconssigdate[2] + "/" + formatconssigdate[1] + "/" + formatconssigdate[0];

          var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            content: [

              { text: 'NET METERING/EXIM metering Connection Agreement', style: 'header' },

              { text: '-'.repeat(150) },

              {
                text: [
                  'This Agreement is made and entered into at ', { text: location, style: 'boldText' }, ' Assam on this ',
                  { text: conssigdateformatted, style: 'boldText' },
                  ', between', 'The Eligible Consumer, by the name of  ',
                  { text: ConsName, style: 'boldText' },
                  { text: '(Consumer No:' },
                  { text: ConsNo, style: 'boldText' },
                  { text: ')' },
                  ', having premise at ',
                  { text: NetAdd, style: 'boldText' },
                  ', as first party.\n\n',
                  { text: 'AND', alignment: 'center' },
                  '\n\n',
                  { text: 'Assam Power Distribution Licensee', style: 'boldText' },
                  ' (herein after called as Discom) represented by  SDE  ',
                  { text: subDivisionName, style: 'boldText' }, ,
                  ', and having its registered office at ',
                  { text: 'Guwahati, Assam', style: 'boldText' },
                  ' as second party of the agreement.\n',
                  'Whereas, the eligible consumer has taken the responsibility to set up or facilitate the requisite Photovoltaic system of capacity ',
                  { text: capacity, style: 'boldText' },
                  ' KWp and sought connectivity to the Discoms under NET metering/ EXIM metering arrangement.\n',
                  'And whereas, the Discoms agrees to benefit the eligible consumer for the electricity generated from the grid Interactive SPV plant into the power system of Discoms as per conditions of the agreement and AERC (Grid Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.\n\n',
                  { text: 'Both the parties hereby agree as follows:', style: 'boldText' }
                ], style: 'normalText'
              },

              { text: '1. Eligibility', style: 'agreementHeader' },


              { text: '1.1 Eligible consumer is required to be aware, in advance, of the standards and conditions that the system has to meet for being integrated into the grid/distribution system.', style: 'normalText' },
              { text: '1.2 Eligible consumer agrees that connection of Photovoltaic system to DISCOM\'s distribution system shall be bound by requirements of state Distribution Code and/or DISCOM\'s conditions of service. The grid shall continue to perform with specified reliability, security, and quality as per the Central Electricity Authority Technical Standards for Connectivity of Distributed Generated Resources Regulations, 2014 of the Central Electricity Authority as amended from time to time.', style: 'normalText' },
              { text: '1.3 The eligible consumer shall also agree to conform to the specifications and standards applicable to the solar PV systems as may be prescribed by the Ministry of New and Renewable Energy Sources, Govt. of India, from time to time.', style: 'normalText' },





              { text: '2. Technical and Interconnection Requirements', style: 'agreementHeader' },


              { text: '2.1 Eligible consumer agrees that he has installed or will install, prior to connection of the photovoltaic system to DISCOM\'s distribution system, an isolation device (both automatic and inbuilt within inverter and external manual relays) and agrees for the DISCOM to have access to and operation of this, if required, for repair and maintenance of the distribution system.', style: 'normalText' },
              { text: '2.2 Eligible consumer agrees that in case of a power outage on DISCOM\'s system, the photovoltaic system will shut down, unless special transfer and isolating capabilities have been installed on the photovoltaic system.', style: 'normalText' },
              { text: '2.3 All the equipment connected to the distribution system must be compliant with relevant international (IEEE/IEC) or Indian standards (BIS), and installations of electrical equipment must comply with Indian Electricity Rules, 1956, and Central Electricity Authority (Measures of Safety and Electricity Supply) Regulations, 2010.', style: 'normalText' },
              { text: '2.4 Eligible consumer agrees that DISCOM will specify the interface/inter-connection point and metering point.', style: 'normalText' },
              { text: '2.5 Eligible consumer agrees to adhere to the following power quality measures as per International or Indian standards and/or other such  measures provided by the Commission/DISCOM:', style: 'normalText' },





              { text: 'a. Harmonic current: Harmonic current injections from a generating station shall not exceed the limits specified in IEEE 519.', style: 'normalText' },
              { text: 'b. Synchronization: The photovoltaic system must be equipped with a grid frequency synchronization device.', style: 'normalText' },
              { text: 'c. Voltage: The voltage-operating window should minimize nuisance tripping and should be under operating range of  80%-110% of the nominal connected voltage. Beyond a clearing time of 2 seconds, the photovoltaic system must isolate itself from the grid.', style: 'normalText' },
              { text: 'd. Flicker: Operating of the photovoltaic system should not cause voltage flicker in excess of  the limits stated in the relavant sections of  IEC standards or  other equivalent Indian standards, if any.', style: 'normalText' },
              { text: 'e. Frequency: When the distribution system frequency deviates outside the specified conditions (50.5Hz on upper side and 47.5Hz on lower side) , the photovoltaic system should not energize the grid and should shift to island mode.', style: 'normalText' },
              { text: 'f. DC injection: The photovoltaic system should not inject DC power more than 0.5% of full-rated output at the interconnection point or 1%  rated inverter output current into distribution system under any operating conditions.', style: 'normalText' },
              { text: 'g. Power factor: When the output of the inverter  is greater than 50%, a lagging power factor of greater than 0.9 should operate.', style: 'normalText' },
              { text: 'h. Islanding and Disconnection: The photovoltaic system in the event of voltage or frequency variations must island/disconnected itself within IEC standard on stipulated period.', style: 'normalText' },
              { text: 'i. Overload and Overheat: : The inverter should have the facility to automatically switch off in case of overload or overheating and shall restart when normal conditions are restored.', style: 'normalText' },
              { text: 'j. Paralleling device:Paralleling device of Photovoltaic system shall be capable of withstanding 220% of the nominal voltage at the interconnection point..', style: 'normalText' },


              { text: '2.6	  Eligible consumer agrees to furnish all the data such as voltage, frequency, and. breaker, isolator position in his system, as and when required by the Discom. He may also try to provide facilities for online transfer of the operational data.', style: 'normalText' },
              { text: '2.7	  The Eligible consumer shall not use a “hybrid inverter” i.e., a ‘solar inverter’ provision of feeding power to the grid.', style: 'normalText' },

              { text: '3. Safety', style: 'agreementHeader' },

              { text: '3.1 Eligible consumer shall comply with the provisions of Central Electricity Authority (Measures Relating to Safety and Electricity Supply) Regulations 2010 and relevant provisions of the National Electrical Code, particularly those related to Solar PV installations.', style: 'normalText' },
              { text: '3.2 Eligible Consumer agrees that the design, installation, maintenance and operation of the photovoltaic system are performed in a manner conducive to the safety of the photovoltaic system as well as the Discom\'s distribution system.', style: 'normalText' },
              { text: '3.3 Due to DISCOM\'s obligation to maintain a safe and reliable distribution system, eligible consumer agrees that if it is determined by Discom that eligible consumer\'s photovoltaic system either causes damage to and or produces adverse effects affecting other distribution systems consumers or DISCOM\'s assets, eligible consumer will have to disconnect photovoltaic system immediately from the distribution system upon direction from the Discom and correct the problem at his own expense prior to a reconnection.', style: 'normalText' },


              { text: '4. Clearances and Approvals', style: 'agreementHeader' },


              { text: '4.1 The eligible consumer agrees to attain all the necessary approvals and clearances (environmental and grid connected related) before connecting the photovoltaic system to the distribution system.', style: 'normalText' },

              { text: '5. Access and Disconnection', style: 'agreementHeader' },

              { text: '5.1 DISCOM shall have access to metering equipment and disconnecting means of the photovoltaic system, both automatic and manual, at all times.', style: 'normalText' },
              { text: '5.2	In emergency or outage situation, where there is no access to a disconnecting means, both automatic and manual, such as a switch or breaker, Discom may disconnect service to the premise', style: 'normalText' },



              { text: '6. Liabilities', style: 'agreementHeader' },


              { text: '6.1	Eligible consumer and Discom will indemnify each other for damages or adverse effects from either party\'s negligence or intentional misconduct in the connection and operation of photovoltaic system or DISCOM\'s distribution system.', style: 'normalText' },
              { text: '6.2	Discom and eligible consumer will not be liable to each other for any loss of profit or revenues, business interruption losses, loss of contract or loss of goodwill, or for indirect, consequential, incidental or special damages, including, but not limited to, punitive or exemplary damages, whether any of the said liability, loss or damages arise in contract, or otherwise.', style: 'normalText' },
              { text: '6.3Discom shall be liable for delivery or realization by eligible consumer for any fiscal or other incentive provided by the central government.', style: 'normalText' },

              { text: '7. Commercial Settlement', style: 'agreementHeader' },

              { text: '7.1	All the commercial settlement under this agreement shall follow Regulations of Assam Electricity Regulatory Commission.', style: 'normalText' },




              { text: '8. Connection Costs', style: 'agreementHeader' },

              { text: '8.1	The eligible consumer shall bear all costs related to setting up of photovoltaic system including metering and interconnection costs. The eligible consumer agrees to pay the actual cost of modifications and upgrades to the distribution facilities required to connect photovoltaic system in case it is required.', style: 'normalText' },
              { text: '8.2	Cost for interconnection equipment including the isolators, meters etc. are also to be borne by the eligible consumer.', style: 'normalText' },


              { text: '9. Termination', style: 'agreementHeader' },


              { text: '9.1	The eligible consumer can terminate agreement at any time by providing Discom with 90 days prior notice.', style: 'normalText' },
              { text: '9.2 Discom has the right to terminate Agreement on 30 days prior written notice, if eligible consumer breaches a term of this Agreement and does not remedy the breach within 30 days of receiving written notice from Discom of the breach.', style: 'normalText' },
              { text: '9.3 Eligible consumer agrees that upon termination of this Agreement, he must disconnect the photovoltaic system from DISCOM\'s distribution system in a timely manner and to DISCOM\'s satisfaction', style: 'normalText' },



              {
                text: [
                  'I hereby undertake that I have taken the responsibility to set up or facilitate the requisite Photovoltaic system of capacity ', { text: capacity }, ' KWp and sought connectivity to the Discom under NET metering/ EXIM metering arrangement.',
                  'And whereas, the Discom agrees to benefit the eligible consumer for the electricity generated from the grid Interactive SPV plant into the power system of Discom as per conditions of the agreement and AERC (Grid Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.',
                ],
                style: 'cursiveStyle',
              },

              { text: ['Date: ', { text: conssigdateformatted, style: 'boldText' }], style: 'normalText' },
              // { text: ['Place: ', { text:location, style: 'boldText' }], style: 'normalText' },
              { text: ['Consumer Name: ', { text: ConsName, style: 'boldText' }], style: 'normalText' },

              {
                text: [
                  'In the witness, where of Mr.',
                  { text: witness, style: 'boldText' },
                  ', for and on behalf of ',
                  { text: ConsName, style: 'boldText' },
                  ', and  SDE ',
                  { text: subDivisionName, style: 'boldText' },
                  'for and on behalf of',

                  { text: 'Assam Power Distribution Licensee ', style: 'boldText,underline' },
                  ' (Discom) agree to this agreement',
                ], style: 'cursiveStyle'
              },
              {
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      {
                        stack: [
                          { text: 'Consumer Signature:', style: 'boldText' },
                          {
                            image: `data:image/jpg;base64,${consumerSignatureUrl}`,
                            width: 70,
                            height: 30,
                            alignment: 'left'
                          },
                          { text: 'Date: ' + conssigdateformatted, style: 'normalText' }
                        ]
                      },
                      {
                        stack: [
                          { text: 'Witness Signature:', style: 'boldText' },
                          {
                            image: `data:image/jpg;base64,${witnessSignatureUrl}`,
                            width: 70,
                            height: 30,
                            alignment: 'left'
                          },
                          { text: 'Date: ' + conssigdateformatted, style: 'normalText' }
                        ]
                      },
                      {
                        stack: [
                          { text: 'SDO Signature:', style: 'boldText' },
                          sdeSignatureUrl ? {
                            stack: [
                              { image: `data:image/jpg;base64,${sdeSignatureUrl} `, width: 70, height: 30 },
                              { text: `Date: ${sdeSignatureDateformatted}`, style: 'normalText' }
                            ]
                          } : { text: 'Signature to be uploaded' },
                          /*{ text: 'Date: ' + currDateFormatted, style: 'normalText' }*/
                        ]
                      },
                    ]
                  ]
                },
                layout: 'noBorders'
              }


            ],
            footer: function (currentPage, pageCount) {
              return {
                text: "Page " + currentPage + ' of ' + pageCount, alignment: 'center', fontSize: 7
              }
            },

            styles: {
              ul: {
                margin: [0, 0, 0, 0],
                bulletColor: 'transparent', // Makes bullets invisible
              },
              header: {
                fontSize: 10,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 5]
              },
              heading: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 5],
                decoration: 'underline'
              },
              normalText: {
                fontSize: 9,

                margin: [0, 5, 0, 5]
              },
              boldText: {
                fontSize: 9,
                bold: true,
                margin: [0, 5, 0, 5],
                decoration: 'underline'
              },
              removelist: {
                fontSize: 9,
                margin: [0, 5, 0, 5],
                listType: 'none'
              },
              cursiveStyle: {
                fontSize: 9,
                italics: true,
                margin: [0, 5, 0, 5]

              },
              agreementHeader: {
                fontSize: 9,
                bold: true,
                margin: [0, 10, 0, 5],
                listType: 'none'
              },
            },
          };

          // Generate  PDF 
          pdfMake.createPdf(docDefinition).open();
          pdfMake.createPdf(docDefinition).download("NetAgreement" + ".pdf");
          /*this.$bvToast.toast("Application submitted and Agreement generated successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });
        */
          setTimeout(function () { window.location.reload(); }, 2000);




        })
        .catch((e) => {
          this.show = false;
          // console.log("Caught", e.response.data.error);
          console.log("Error");

        });


      return;

    },
    closeModal() {
      this.$bvModal.hide('model')
    },
    reloadPage() {
      window.location.reload();
    },
    redirect() {
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("consList");
      sessionStorage.removeItem("selectedCons");
      window.location.href = "/website/";
      return false;
    },
    switchConsumer() {
      this.show = true;
      var consNo = document.getElementById("consList").value;

      var consType;

      var parent = this;
      let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getConsDetails',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;
          //console.log(response.data);
          if (response.data.message == "00") {
            sessionStorage.setItem("selectedCons", consNo);
            consType = response.data.connType;
            // subdivisionNameGlobal = response.data.subDivisionName;

            if (consType == "POSTPAID") {
              window.location.href = "/website/ConsumerDashboardPostpaid";
              return false;
            }
            else if (consType == "SMART POSTPAID") {
              window.location.href = "/website/ConsumerDashboardSmartPostpaid";
              return false;
            }
            else if (consType == "PREPAID") {
              window.location.href = "/website/ConsumerDashboardPrepaid";
              return false;
            }
            else if (consType == "SMART PREPAID") {
              window.location.href = "/website/ConsumerDashboardSmartPrepaid";
              return false;
            }
          }
          else {
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
          }
        })
        .catch((e) => {
          parent.show = false;
          console.log("Caught :::::::::::::::", e.message);
          if (e.response.data.error == "Forbidden") {
            parent.$bvModal.show('redirectModal');
            document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
          }
        });

    },
    getSmartBalance(action) {

      //console.log("this.smartBalance::::"+this.smartBalance)
      if ((action == "change") || (action == "click" && this.smartBalance == "O")) {
        var consNo = document.getElementById("consList").value;
        this.show = true;
        var parent = this;


        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/smartPrepaidBalance',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            parent.show = false;
            //  console.log(response.data);
            document.getElementById("smartBalance").innerHTML = " ₹" + response.data.consDetails.availableBalance;
            parent.smartBalance = response.data.consDetails.availableBalance;
          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumer not found";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    getExcessPaymentHistory(action) {
      if ((action == "change") || (action == "click" && this.excessPaymentHistory.length == 0)) {
        var consNo = document.getElementById("consList").value;
        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/smartPrepaidRechargeHistory',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            this.show = false;
            var data = response.data;
            var temp = [];
            data.forEach(element => {
              // console.log(element.cons_no);
              var obj = {
                "receipt": element.receipt_no,
                "amount": element.amount,
                "date": element.date,
                "mode": element.mode,
                "claim": "<a style='padding:10px;color:#ffff;background-color:#f74808;box-shadow:1px 2px 4px 0px grey' href='#' onclick='showExcessPayementModal(\"" + element.cons_no + "\",\"" + element.receipt_no + "\")'>SELECT</a>"
              }
              temp.push(obj)

            })
            // console.log(temp)
            parent.excessPaymentHistory = temp;

          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    showExcessPayementModal(consNo1, receiptNo) {
      // console.log("consNo1 Modal::"+consNo1);
      // console.log("receiptNo Modal::"+receiptNo);
      bankConsNo = consNo1;
      bankReceiptNo = receiptNo;

      let data = JSON.stringify({
        "consNo": "" + bankConsNo + "",
        "receiptNo": "" + bankReceiptNo + "",
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getPrevApp',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          parent.show = false;
          var data = response.data;
          if (data.message == "available") {
            rcAmt = data.admissibleRefund;
            rcAddAmt = data.addedFees;
            rcName = data.consName;
            rcOffice = data.code;
            rcDate = data.date;
            rcApplNo = data.applNo;
            parent.$bvModal.show('existModal');
          }
          else if (data.message == "not available") {
            parent.$bvModal.show('excessPaymentModal');
          }
          else {
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Error. Please try again.";
          }
        })

    },

    calculateExcessPayement() {

      var userAmount = document.getElementById("excessAmountUser").value;
      if (userAmount == "") {
        this.$bvToast.toast('Please Enter Amount', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      // console.log("consNo:::"+bankConsNo+"||receiptNo:::"+bankReceiptNo+"||userAmount:"+userAmount)

      let data = JSON.stringify({
        "consNo": "" + bankConsNo + "",
        "receiptNo": "" + bankReceiptNo + "",
        "consumerRefund": "" + userAmount + "",
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getAdmissibleRefund',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          this.show = false;
          var data = response.data;
          if (data.message == "Eligible for refund.") {
            rcAmt = data.admissibleRefund;
            rcAddAmt = data.addedFees;
            parent.$bvModal.hide('excessPaymentModal')
            document.getElementById("excessPaymentDiv").style.display = "none";
            document.getElementById("refundAmountDiv").style.display = "block";
            document.getElementById("bankDetailsDiv").style.display = "none";
            document.getElementById("addmissibleAmount").innerHTML = "₹" + data.admissibleRefund;
            document.getElementById("additionalCharge").innerHTML = "₹" + data.addedFees;
          }
          else {
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = data.message;
          }


        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

        })

    },
    showBankDetails() {
      document.getElementById("excessPaymentDiv").style.display = "none";
      document.getElementById("refundAmountDiv").style.display = "none";
      document.getElementById("bankDetailsDiv").style.display = "block";
    },
    saveBankDetails() {
      var accountNo = document.getElementById("accountNo").value;
      var accountName = document.getElementById("accountName").value;
      var bankBranch = document.getElementById("bankBranch").value;
      var bankName = document.getElementById("bankName").value;
      var ifcsCode = document.getElementById("ifcsCode").value;
      var micrCode = document.getElementById("mcirCode").value;

      let data = JSON.stringify({
        "consNo": "" + bankConsNo + "",
        "receiptNo": "" + bankReceiptNo + "",
        "mobileNo": mobile,
        "bankAccNo": accountNo,
        "bankAccName": accountName,
        "bankName": bankName,
        "branchName": bankBranch,
        "ifsc": ifcsCode,
        "micr": micrCode
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/saveRefundApp',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          this.show = false;
          var data = response.data;
          if (data.status == "success") {
            rcName = data.consName;
            rcOffice = data.subDivName;
            rcDate = data.date;
            rcApplNo = data.applNo;
            parent.$bvModal.show('successModal');
            parent.successMsg = data.message;

          }
          else {
            parent.$bvModal.show('failureModal');
            parent.failureMsg = data.message;
            // document.getElementById("failureMsg").innerHTML=data.message;
          }


        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught ::::", e.message);
        })


    },

    generateUndertakingPdf() {

      var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          { image: 'data:image/png;base64,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', style: 'logo', },

          { text: 'ASSAM POWER DISTRIBUTION COMPANY LIMITED', style: 'header' },
          { text: 'Office:' + rcOffice, style: 'subheader' },

          { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },
          { text: ['Unique Application No: ', { text: rcApplNo, style: 'boldText' },], style: 'normalText' },
          { text: '\nDECLARATION', style: 'header' },
          {
            text:
              [


                '\n I hereby undertake that all the details submitted herein are true and correct. I also undertake that the decision of APDCL on the refund of Rs. ', { text: rcAmt, style: 'boldText' }, ' is final and unconditionally acceptable to me.',
                ' Also, I understand and unconditionally accept that actual refund amount would be after deduction of additional bank charges of Rs. ', { text: rcAddAmt + ".", style: 'boldText' },
                '\n\nI also undertake to indemnify APDCL from any delay in receipt of the admitted refund amount as well as any deduction thereon in the chosen mode of payment (bank/gateway/wallet etc.).   ',
                '\n\nI also undertake that this instant application of refund and proceeds thereunder will not be mentioned by the undersigned in any form/manner in any other forum in future.',
                'I also undertake that in the event of any deviation from the aforementioned terms on part of the undersigned, APDCL is entitled to take all available recourses including levy of charge for the entire amount of refund as penalty at any point of time and I will have no claim over it forever.',
              ],
            style: 'normalText', alignment: 'justify'
          },

          { text: ['\nApplicant Name: ', { text: rcName, style: 'boldText' },], style: 'normalText' },
          { text: ['Date: ', { text: rcDate, style: 'boldText' },], style: 'normalText' },

        ],
        styles: {
          logo:
          {
            alignment: 'center',
            height: 50,
            width: 50
          },
          header: {
            fontSize: 15,
            bold: true,
            alignment: 'center',
            margin: [0, 5, 0, 5]
          },
          subheader: {
            fontSize: 15,
            alignment: 'center',
            bold: true,
            margin: [0, 5, 0, 5]
          },
          applNo: {
            fontSize: 13,
            alignment: 'center',
            color: '#0277bd',
            margin: [0, 10, 0, 5]
          },
          heading: {
            fontSize: 12,
            alignment: 'left',
            bold: true,
            margin: [0, 10, 0, 5]
          },
          normalText: {
            fontSize: 12,
            alignment: 'left',
            margin: [0, 10, 0, 5]
          },
          boldText: {
            fontSize: 12,
            alignment: 'left',
            bold: true,
            margin: [0, 10, 0, 5]
          },
          bottomText: {
            fontSize: 10,
            fontWeight: 600,
            alignment: 'left',
            margin: [0, 10, 0, 5]
          },
          footerText: {
            fontSize: 8,
            alignment: 'left',
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 5, 0],
            alignment: 'left',
            fontSize: 10,
          }
        },

      };

      pdfMake.createPdf(docDefinition).download("Declaration" + "cons_name" + ".pdf");
      // setTimeout(function(){ window.location.reload(); }, 2000);

    },
    downloadBillAssamese(consNo, billNo) {
        let dataDownload = {
        consNo: consNo,
        mobileNo: mobile,
        billNo: billNo,
        language: "assamese"
      };

      console.log(JSON.stringify(dataDownload))

      axios({
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/postpaid/bill/download',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: 'blob',   // IMPORTANT
        data: dataDownload
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Bill_${billNo}.pdf`;
          link.click();

        })
        .catch(error => {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Unable to download bill";
          console.error(error);
        });
    },
    downloadBillEnglish(consNo, billNo) {
        let dataDownload = {
        consNo: consNo,
        mobileNo: mobile,
        billNo: billNo,
        language: "english"
      };

      axios({
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/postpaid/bill/download',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: 'blob',   // IMPORTANT
        data: dataDownload
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Bill_${billNo}.pdf`;
          link.click();

        })
        .catch(error => {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Unable to download bill";
          console.error(error);
        });
    },

    getBillHistory(action) {

      if ((action == "change") || (action == "click" && this.consumerBill.length == 0)) {
        var consNo = document.getElementById("consList").value;

        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/billData',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            this.show = false;
            var temp = [];
            response.data.billData.forEach(element => {
              var res1 = element.bill_DATE.split("-");
              var billDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
              var res2 = element.due_DATE.split("-");
              var dueDateFormatted = res2[2] + "/" + res2[1] + "/" + res2[0];
              var dueAmt = "";

              if (element.due_AMOUNT == 0) dueAmt = "Paid";
              else dueAmt = element.due_AMOUNT;
              let subdivision = consNo.substring(0, 3);
              let masked = 'x';

              var obj = {
                bill_no: element.bill_NO,
                bill_date: billDateFormatted,
                due_date: dueDateFormatted,
                due_amt: "<span style='padding-left:35%'>" + dueAmt + "<span>",
                net_amt: "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
                consNo: consNo   // 👈 required for download
              };
              temp.push(obj);
            })
            // console.log(temp)
            parent.consumerBill = temp
          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },

    getRechargeHistory(action) {
      //console.log("this.voucherList.length::::"+this.voucherList.length)

      if ((action == "change") || (action == "click" && this.voucherList.length == 0)) {
        var consNo = document.getElementById("consList").value;

        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/smartPrepaidRechargeHistory',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {
            parent.show = false;
            //  console.log(response.data);

            var temp = [];
            response.data.forEach(element => {
              var res1 = element.date.split("-");
              var paymentDt = res1[2] + "/" + res1[1] + "/" + res1[0];
              var obj = {
                "receipt": element.receipt_no,
                "amount": element.amount,
                "date": element.date,
                "mode": element.mode,
              }
              temp.push(obj)

            })
            //console.log(temp)
            this.voucherList = temp
          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumer / Voucher not found";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    viewStatement() {
      var consNo = document.getElementById('consList').value;

      if (this.selectedMonth == null) {
        this.$bvToast.toast('Select a Month !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
      }
      if (this.selectedYear == null) {
        this.$bvToast.toast('Select a Year !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
      }
      if (this.selectedLanguage == null) {
        this.$bvToast.toast('Select a Language !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
      }

      let data = {
        consNo: consNo,
        month: this.selectedMonth,
        year: String(this.selectedYear),
        mobileNo: mobile,
        language: this.selectedLanguage
      };

      // console.log("data::" + JSON.stringify(data))
      // return;
      this.show = true;
      axios({
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/smartPrepaid/statement/download',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: 'blob',   // IMPORTANT
        data: data
      })
        .then(response => {
          this.show = false;
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.selectedMonth}_${this.selectedYear}_statement.pdf`;
          link.click();
        })
        .catch(error => {
          this.show = false;
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Unable to download statement";
          console.error(error);
        });

      // let shortCode = 'p' + consNo + this.selectedMonth + this.selectedYear;

      // window.open('https://www.apdcl.org/tu/?s=' + shortCode, '_blank');

      /*
            if(lang=='ass'){
              window.open('https://www.apdcl.org/pdfEngine/v2/prepaidStatement?consNo='+consNo+'&month='+this.selectedMonth+'&year='+this.selectedYear+'&lang=assamese', '_blank');      
            }
            else
              window.open('https://www.apdcl.org/pdfEngine/v2/prepaidStatement?consNo='+consNo+'&month='+this.selectedMonth+'&year='+this.selectedYear, '_blank');  
            */
    },

    downloadFile() {
      const link = document.createElement('a');
      link.href = this.invoicePDF;
      link.setAttribute('download', 'monthly_statement.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    showConsDetails(action) {

      if ((action == "change") || (action == "click" && this.consDetails.length == 0)) {
        var consNo = document.getElementById('consList').value;
        this.show = true;

        var parent = this;
        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/getConsDetails',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };
        let mapping = {
          method: 'post',
          url: this.$urlCommon + '/api/web/auth/getDistrictMapping?consNo=' + consNo,
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };
        var parent = this;
        axios.request(config)
          .then((response) => {
            parent.show = false;
            //console.log(response.data);
            if (response.data.message == "00") {
              var data = response.data;
              oldMob = data.mobile_no;
              document.getElementById("consumerNumber").innerHTML = data.cons_no;
              consumerNumberGlobal = data.cons_no;
              document.getElementById("consumerName").innerHTML = data.cons_name;
              document.getElementById("mobile").value = data.mobile_no;
              consumermobileGlobal = data.mobile_no;
              consumerNameGlobal = data.cons_name;
              consumerAddressGlobal = data.cons_ADD1;
              subdivisionNameGlobal = data.subDivisionName;
              document.getElementById("email").value = data.email;

              var distCode = data.district;
              var container = document.getElementById("districtContainer");

              if (!distCode || distCode.trim() === "") {
                this.districtFlag = true;
                axios.request(mapping)
                  .then(function (response) {
                    const districts = response.data;

                    let options = '<option value="">Please select a District</option>';
                    Object.entries(districts).forEach(([districtName, districtCode]) => {
                      options += `<option value="${districtName} - ${districtCode}">${districtName}</option>`;
                    });

                    container.innerHTML = `
                    <select class="form-control mb-3" id="districtDropdown">
                      ${options}
                    </select>
                  `;
                  })
                  .catch(function (error) {
                    console.error("Error fetching district mapping:", error);
                  });
              } else {
                var districtName = distCode.split(" - ")[0];
                var districtCode = distCode.split(" - ")[1];

                container.innerHTML = `
                <span id="districtName" data-code="${districtCode}">${districtName}</span>
              `;
              }

              parent.selected = data.occupation;
              // if (data.voter_ID== null || data.voter_ID=="")
              //    document.getElementById("voterId").placeholder = "Enter Voter No";
              // else
              //    document.getElementById("voterId").placeholder = data.voter_ID;
              parent.consDetails.push(data.cons_no);
            }
            else {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
            }

          })
          .catch((e) => {
            parent.show = false;
            console.log("Caught", e);

            if (e.response.data.error == "Forbidden") {
              parent.$bvModal.show('redirectModal');
              document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
            }

          })
      }
    },

    showTdsAdjustment(action) {
      if ((action == "change") || (action == "click" && this.tdsAdjustment.length == 0)) {
        var consNo = document.getElementById("consList").value;
        var parent = this;
        this.show = true;

        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/tdsStatement',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            //console.log(response.data);
            parent.show = false;
            var status = response.data.status;
            var data = response.data.tdsStatement;
            var temp = [];
            var i = 1;
            if (status === "Success" && data.length > 0) {
              // document.getElementById("tdsTable").style.display = "block";
              this.showTdsTable = true;
              document.getElementById("tdsSpan").style.display = "none";
              data.forEach(element => {
                // var res1= element.payment_DATE.split("-");
                // var paymentDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];
                var processedDate = "---"
                if (element.processed_DATE != null)
                  processedDate = element.processed_DATE.split("T")[0];
                var uploadDate = "---"
                if (element.upload_DATE != null)
                  uploadDate = element.upload_DATE.split("T")[0];
                var obj = {
                  "sl_no": i++,
                  "cons_no": element.cons_NO,
                  "tan_no": element.tan_NO,
                  "bill_no": element.bill_NO,
                  "tds_amt": element.tds_AMT_DEDUCTED,
                  "challan_no": element.challan_NO,
                  "challan_date": element.challan_DATE,
                  "challan_amt": element.challan_AMT,
                  "upload_date": uploadDate,
                  "processed_flag": element.processed_FLAG,
                  "processed_date": processedDate,
                  "challan_link": "<a style='padding-left:40%' target='_blank' href='" + element.challan_LINK + "'><img src='" + parent.$urlCommon + "/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
                }
                temp.push(obj);
              })

              parent.tdsAdjustment = temp;

            }
            else {
              // document.getElementById("tdsTable").style.display = "none";
              this.showTdsTable = false;
              document.getElementById("tdsSpan").style.display = "block";
              document.getElementById("tdsSpan").innerHTML = response.data.message;

            }


          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },

    updateConsumer() {

      //console.log("inside update consumer");
      var consNo = document.getElementById("consList").value;
      var mobNo = document.getElementById("mobile").value;
      var email = document.getElementById("email").value;
      var occupation = document.getElementById("occupation").value;
      // var voterId = document.getElementById("voterId").value;

      var mobregx = /^[5-9]\d{9}$/
      if (!mobregx.test(mobNo)) {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!emailRegex.test(email) && email != "") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid Email !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("email").focus();
        return
      }


      // var voterIdRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
      // if(!voterIdRegex.test(voterId) && voterId != "" )
      //     {
      //       this.$bvToast.toast('Enter Valid Voter ID !', {
      //         title: `Alert`,
      //         variant: 'danger',
      //         solid: true
      //       })
      //       document.getElementById("voterId").focus();
      //     return
      //     }

      let district = null;
      let districtCode = null;

      if (this.districtFlag === true) {
        // Case: selected from dropdown
        const selectedValue = document.getElementById('districtDropdown')?.value;

        if (selectedValue && selectedValue.includes(' - ')) {
          const [districtName, distCode] = selectedValue.split(' - ').map(s => s.trim());
          district = districtName;
          districtCode = distCode;
        } else {
          this.$bvToast.toast('Please select a district!', {
            title: 'Alert',
            variant: 'danger',
            solid: true
          });
          return;
        }
      } else {
        // Case: prefilled, get from span and attribute
        const districtSpan = document.getElementById('districtName');
        district = districtSpan?.innerText?.trim();
        districtCode = districtSpan?.getAttribute('data-code')?.trim();

        if (!district || !districtCode) {
          this.$bvToast.toast('District information is missing!', {
            title: 'Alert',
            variant: 'danger',
            solid: true
          });
          return;
        }
      }

      // console.log("district:::::"+JSON.stringify(district));
      // console.log("districtCode:::::"+JSON.stringify(districtCode));

      let data = JSON.stringify({
        "consNo": consNo,
        "email": email,
        "mobNo": mobNo,
        "occupation": occupation,
        "mobileNo": mobile,
        "district": district,
        "districtCode": districtCode
      });
      // console.log("data::::"+ JSON.stringify(data));

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/updateConsumerDetails',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;
          var msg1 = response.data.status;
          if (msg1 == "success") {

            parent.$bvModal.show('profilesuccessModal');
          }
          else {

            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = response.data.message;
          }
        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Profile Update Failed";
          console.log("Caught :::::::::::::::", e.message);
        })
    },
    newRecharge() {

      consNo = document.getElementById("consList").value;
      var parent = this;

      if (consNo.toString().length != 12) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return;
      }

      let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/prepaidRecharge',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };
      var parent = this;
      this.show = true;
      axios.request(config)
        .then((response) => {
          parent.show = false;
          var data = response.data.prepaidConsDetails;
          var msg = response.data.message;

          if (msg == "Valid") {

            sdCode = data.sdCode;
            consName = data.consumerName;
            vendor = data.vendorName;
            isSmart = data.isSmart;
            document.getElementById("consNamePrepaid").innerHTML = data.consumerName;
            document.getElementById("subDiv").innerHTML = data.address;
            document.getElementById("meterNo").innerHTML = data.meterNo;
            // document.getElementById("category").innerHTML=data.categoryName;
            parent.show = false;
            document.getElementById("BillDetails").classList.add("showBillDetails");
          }
          else {
            // console.log("inside Error")
            parent.show = false;
            document.getElementById("BillDetails").style.display = "none";
            parent.$bvModal.show("model");
            if (data.errorcode == "No connection to secure service." || data.errorcode == "Could not connect Genus services")
              document.getElementById("modalMsg").innerHTML = "Error Connecting to Prepaid Meter Server";
            else
              document.getElementById("modalMsg").innerHTML = msg;

          }
        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

        })


    },
    payNow() {
      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      var amountPaid = document.getElementById("amount").value;
      var confirmAmount = document.getElementById("confirmAmount").value;
      if (emailId == "") {
        emailId = "NA";
      }

      if (amountPaid != confirmAmount) {
        this.$bvToast.toast('Enter same amount  !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("confirmAmount").focus();
        return;
      }

      if ((amountPaid < 100 || amountPaid > 5000) && isSmart != "Y") {
        this.$bvToast.toast('Enter Amount between Rs. 100.00 - Rs. 5000.00 !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("amount").focus();
        return;
      }
      if ((parseInt(amountPaid) % 100) != 0) {
        this.$bvToast.toast('Enter Amount Multiple of 100 !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("amount").focus();
        return;
      }
      if (mobileNo.length != 10) {
        this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("mobileNo").focus();
        return;
      }


      var dataToSend = {
        "consNo": consNo,
        "amountPaid": amountPaid,
        "mobileNo": mobileNo,
        "email": emailId,
        "consName": consName,
        "vendor": vendor
      }
      //console.log(dataToSend);



      document.getElementById("consBillDiv").style.display = "none";
      document.getElementById("billdeskRequestDiv").style.display = "block";
      var parent = this;

      function isMobile() {
        return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
      }

      if (isMobile()) {
        axios.post(this.$urlCommon + '/api/v2/onlineprepaid/pgrequest', dataToSend)
          .then((response) => {
            // console.log(response.data);
            var data = response.data;
            var status = response.data.message;

            if (status == "00") {
              parent.reqUrl = data.action;
              parent.messageToSend = data.msg;
              setTimeout(function () { document.getElementById("submit").click(); }, 2000);
            }
            else {
              document.getElementById('spinner').style.display = 'none';
              document.getElementById('errorDiv').style.display = 'block';
              document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
              this.$bvModal.show("model");
              document.getElementById("msg").innerHTML = parent.message[parseInt(status)];
            }
          })
          .catch((e) => {
            console.log("Caught", e);
            this.show = false;
            this.$bvModal.show("model");
            document.getElementById("msg").innerHTML = e;
            document.getElementById("BillDetails").classList.remove("showBillDetails");
          })
      } else {
        axios.post(this.$urlCommon + '/api/v2/onlineprepaid/pgrequest', dataToSend)
          .then((response) => {
            console.log("response data:::::" + JSON.stringify(response.data));

            var data = response.data;
            var status = response.data.message;

            var reqUrl = "";
            var messageToSend = "";

            if (status == "00") {
              reqUrl = data.action;
              messageToSend = data.msg;
              const dataToNewPage = { reqUrl: reqUrl, messageToSend: messageToSend };
              const queryString = new URLSearchParams(dataToNewPage).toString();
              window.open(`/website/ConsumerDashboardBBPSpage?${queryString}`, '_blank', "noopener,noreferrer");
              window.location.reload();
            }
            else {
              document.getElementById('spinner').style.display = 'none';
              document.getElementById('errorDiv').style.display = 'block';
              document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
              this.$bvModal.show("model");
              document.getElementById("msg").innerHTML = parent.message[parseInt(status)];
            }
          })
          .catch((e) => {
            console.log("Caught", e);
            this.show = false;
            this.$bvModal.show("model");
            document.getElementById("msg").innerHTML = e;
            document.getElementById("BillDetails").classList.remove("showBillDetails");
          })
      }

    },
    closeModal() {
      this.$bvModal.hide('model')
    },
    closeModalH() {
      this.$bvModal.hide('holdingModal')
    }

  },
  mounted() {
    const d = new Date();
    let year = d.getFullYear();
    var temp = [{ value: null, text: 'Please Select Year' }];
    for (var i = 2023; i <= parseInt(year); i++) {
      var obj = { value: i, text: i };
      temp.push(obj);
    }

    this.yearOptions = temp;

    if (sessionStorage.getItem("accessToken")) {
      mobile = sessionStorage.getItem("mobile");
      accessToken = sessionStorage.getItem("accessToken");
      consList = JSON.parse(sessionStorage.getItem("consList"));
      //console.log("consList Length::::"+consList.length)
      if (parseInt(consList.length) > 0) {
        consList.forEach(element => {
          var option1 = document.createElement("option");
          option1.text = element;
          option1.value = element;
          var select1 = document.getElementById("consList");
          select1.appendChild(option1);
        })
        document.getElementById("consList").value = sessionStorage.getItem("selectedCons");
        this.showConsDetails('change');

      }
      else {
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML = "No Consumer Mapped to This Mobile number";

      }
    }
    else {
      this.$router.push({ path: '/' })

    }


  },
  created() {
    window.calculateExcessPayement = this.calculateExcessPayement;
    window.showExcessPayementModal = this.showExcessPayementModal;


  }


}

</script>


<style scoped="true">
#loader {
  height: 100%;
  min-height: 100%;
  width: 100%;

}

.agreement {
  font-weight: 600;
  color: #263238;

}

.declaration {
  color: #263238;
  font-weight: 600;
  text-decoration: underline;
}

.agreement-container {
  width: 98%;
  max-width: 1000px;
  margin: 20px auto;
  padding: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.agreement-content {
  height: 400px;
  overflow-y: auto;
  padding: 15px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
}

.agreement-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.center {
  text-align: center;
  font-weight: bold;
}

.agreement h6 {
  margin-top: 20px;
  font-weight: bold;
  color: #007bff;
}

.paddingRow {
  padding: 0.7rem;
}

.label {
  font-weight: 600;
}

.customSelect {

  border: 1px solid #039be5;
  color: #0277bd;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;

}

.customSelect:hover {
  cursor: pointer;
  border: 2px solid #039be5;
  color: #1565c0;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;
}

.modalFont {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}

.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}

.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}

.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}

p.success {
  color: #73AF55;
}

p.error {
  color: #D06079;
}

@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.OnlinePaymentCardStyle {
  padding: 0;
  box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;
  width: 30%;
  margin-left: 35%;
  text-align: center;
  min-height: 50vh;
}

.marginTop {
  margin-top: -10px;
}

.marginTop20px {
  margin-top: none;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .marginTop {
    margin-top: 20px;
  }

  .marginTop20px {
    margin-top: 20px;
  }
}

@media (max-width: 576px) {

  .marginTop20px {
    margin-top: 20px;
  }
}
</style>
